<template>
    <v-card>
        <v-toolbar id="header-dialogue-inbox-full" class="h-auto" content-class="h-auto">
            <div class="d-flex align-items-center">
                <!-- <div style="margin:0 20px 0 0">
                    <v-btn @click="closeDialog(true, true)"
                           class="dgs-new-button" style="width: 40px; min-width: unset !important">
                        <v-icon>mdi-arrow-left</v-icon>
                    </v-btn>
                </div> -->

                <v-toolbar-title v-if="document.referenceNumber == null && document.categoryId == 1"
                    class="size-24 document-title">{{ $t("res_Title_CreateNewIncoming") }}</v-toolbar-title>
                <v-toolbar-title v-if="document.referenceNumber == null && document.categoryId == 2"
                    class="size-24 document-title">{{ $t("res_Title_CreateNewOutgoing") }}</v-toolbar-title>
                <v-toolbar-title v-if="document.referenceNumber == null && document.categoryId == 3"
                    class="size-24 document-title">{{ $t("res_Title_CreateNewInternal") }}</v-toolbar-title>
                <v-toolbar-title v-if="document.referenceNumber == null && document.categoryId == 4"
                    class="size-24 document-title">{{ $t("res_Title_CreateNewDecree") }}</v-toolbar-title>
                <v-toolbar-title v-if="document.referenceNumber == null && document.categoryId == 5"
                    class="size-24 document-title">{{ $t("res_Title_CreateNewCircular") }}</v-toolbar-title>
                <v-toolbar-title v-if="document.referenceNumber != null" class="size-24 document-title">
                    <span class="FullView-Div-DocumentSubject">
                        {{ constants.client_version_Id == 'DEG' ? document.referenceNumber + ' - ' + subject : subject
                        }}
                        <i class="fa fa-info-circle"
                            v-if="templateInfo != '' && templateInfo != null && templateInfo.Id > 0"
                            style="color:#3067E1; font-size:18px; cursor:pointer" aria-hidden="true"
                            @mouseenter="showTemplateInfoCard = true" @mouseleave="showTemplateInfoCard = false"></i>
                    </span>
                    <div v-show="showTemplateInfoCard" id="dgs-card-container">
                        <v-card id="dgs-card"
                            class="bg-white template_card pb-0 d-grid dgs-min-height-120px shadow-lg TemplateCard border-2"
                            :class="`${ this.selectedLang == 'en' ? 'TemplateCard_En' : 'TemplateCard_Ar'}`"
                            style="min-height: 160px; min-width: 300px;">
                            <div class="d-flex flex-row justify-content-between align-items-center"
                                style="margin-bottom:10px">
                                <div class="d-flex flex-column p-0">
                                    <h3 class="mt-0 mb-0 p-0 main-text-large TemplateInfoTitle">{{
                                        this.templateInfo.Tags ? this.templateInfo.Tags + ' - ' : '' }}{{
                                        this.templateInfo.Name }}</h3>
                                </div>
                            </div>
                            <div class="dgs-vchip-flex">
                                <v-chip class="light-blue-dgs">{{ this.templateInfo.Language }}</v-chip>
                                <v-chip class="blue-dgs">{{ this.templateInfo.SignatureCount + ' ' +
                                    this.$t('res_Label_Signature') }}</v-chip>
                            </div>
                        </v-card>
                    </div>
                </v-toolbar-title>
            </div>
            <v-spacer></v-spacer>
            <div class="d-flex align-items-center toolbar-icons">
                <v-btn v-if="!isFavorite && document.templateId != null && document.templateId != ''"
                    class="dgs-new-button-icon" @click="addFavoriteDialog = true" icon
                    v-tooltip="$t('res_Label_AddToFavorite')"><v-icon
                        class="primary-hover">mdi-star-outline</v-icon></v-btn>
                <v-btn v-if="isFavorite" class="dgs-new-button-icon" @click="removeFavoriteDialog = true" icon
                    v-tooltip="$t('res_Label_RemoveFromFavorite')"><v-icon
                        class="primary-hover">mdi-star</v-icon></v-btn>

                <div class="position-relative d-inline">
                    <v-btn class="dgs-new-button-icon" @click="ViewBarcode()" v-tooltip="$t('res_CardHeaders_Barcode')"
                        icon><v-icon>mdi-barcode-scan</v-icon></v-btn>
                    <v-card class="barCode d-flex flex-column" v-if="barcodeFormDialog" v-click-outside="hideBarCode">
                        <div class="img-wrapper d-flex flex-column flex-1 justify-content-center">
                            <img id="barcode" :src="barcodeImage" />
                        </div>
                        <div class="text-center border-top pt-2">
                            <v-btn class="btn-text text-primary weight-500" @click="printBarcode()">Print</v-btn>
                        </div>
                    </v-card>
                </div>

                <v-btn class="dgs-new-button-icon"
                    v-if="document.secretForward !==true && document.categoryId != 1 && document.byTemplate == true" icon
                    @click="createCopyFromLetter" v-tooltip="$t('res_Label_Copy')"><v-icon
                        class="primary-hover">mdi-content-copy</v-icon></v-btn>
                <v-menu v-model="PrintOptions">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn class="dgs-new-button-icon" icon @click="PrintOptions= true" v-bind="attrs" v-on="on"
                            v-tooltip="$t('res_Label_PrintOptions')">
                            <v-icon class="primary-hover">mdi-printer</v-icon>
                        </v-btn>
                    </template>
                    <v-list>
                        <v-list>
                            <v-list-item @click="printWithAttachments">
                                <v-list-item-content>
                                    <v-list-item-title>{{ $t('res_Label_Print') }}</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item @click="printWithAttachmentWithStamps">
                                <v-list-item-content>
                                    <v-list-item-title>{{ $t('res_Label_PrintWithStamps') }}</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item v-if="printWithoutHeaderAndFooterAndWithSignature" @click="printwithoutHeader">
                                <v-list-item-content>
                                    <v-list-item-title>{{ $t('res_Label_PrintWithoutheaderandfooter')
                                        }}</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item @click="printwithoutsignture">
                                <v-list-item-content>
                                    <v-list-item-title>{{ $t('res_Label_PrintWithoutSignature') }}</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </v-list>
                </v-menu>
                <v-menu v-model="DownloadOptions">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn class="dgs-new-button-icon" icon @click="DownloadOptions= true" v-bind="attrs" v-on="on"
                            v-tooltip="$t('res_Label_DownloadOptions')">
                            <v-icon class="primary-hover">mdi-download</v-icon>
                        </v-btn>
                    </template>
                    <v-list>
                        <v-list>
                            <v-list-item @click="downloadCorrespondence(false)">
                                <v-list-item-content>
                                    <v-list-item-title>{{ $t('res_Label_Download') }}</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item v-if="downloadWithoutHeaderAndFooterAndWithSignature"
                                @click="downloadWithoutHeaederAndWithSignature">
                                <v-list-item-content>
                                    <v-list-item-title>{{ $t('res_Label_DownloadWithoutheaderandfooter')
                                        }}</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item @click="downloadAttachmentWithStamps">
                                <v-list-item-content>
                                    <v-list-item-title>{{ $t('res_Label_DownloadWithStamps') }}</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item @click="downloadCorrespondence(true)">
                                <v-list-item-content>
                                    <v-list-item-title>{{ $t('res_ButtonText_DownloadWithAttachments') }}</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </v-list>
                </v-menu>
                <div class="custom-close-icon">
                    <v-icon @click="closeDialog(true, true)">custom-icon mdi-close</v-icon>
                </div>
            </div>
        </v-toolbar>
        <div class="dialog-body h-100">
            <div class="row m-0 h-100">
                <div class="form-section col-12 p-0 m-0 h-100">
                    <!--scrollable-white container-->
                    <div class=" scrollable-container h-100 main-bg-color">
                        <div class="side-components-inner">
                            <div class="apply-button text-end inner-single-component" v-if="canEditDocumentMetaData()"
                                style=" display: flex;justify-content: space-around;">
                                <v-btn text color="primary" class="p-0 btn-color-2 DocumentSave" @click="applyChanges()"
                                    v-if="this.document.categoryId != 1">
                                    <v-icon>mdi-checkbox-marked-circle</v-icon>
                                    {{ $t("res_ButtonText_ApplyChanges") }}
                                </v-btn>

                                <v-btn text color="primary" class="p-0" style="text-decoration: none !important;"
                                    @click="applyChangesAndEdit()"
                                    v-if="this.document.categoryId != 1 && this.selectedAttachmentExtension == 'docx'">
                                    <v-icon id="saveAndEditIcon" class="pl-1 pr-1"
                                        style="font-size:22.5px;color:#215ddf !important">mdi-circle-edit-outline</v-icon>
                                    <span id="saveAndEditIconlbl">{{ $t("res_ButtonText_SaveAndEdit") }}</span>
                                </v-btn>

                                <v-btn text color="primary" class="p-0" @click="applyChanges()"
                                    v-if="this.document.categoryId == 1">
                                    <v-icon>mdi-checkbox-marked-circle</v-icon>
                                    {{ $t("res_ButtonText_Save") }}
                                </v-btn>
                            </div>

                            <div class=" inner-single-component" v-if="transferId != 0 || viewMode == 'readonly'">
                                <div class="form-sub-section view-details-section"
                                    v-if="transferId != 0 || viewMode == 'readonly'" style="margin-bottom: 10px;">
                                    <div class="d-flex justify-content-between">
                                        <div class="d-flex justify-content-between align-items-center">
                                            <h3>{{ $t("res_Label_TransferDetails") }}</h3>
                                        </div>
                                        <v-btn @click="collapseTransferDetails = !collapseTransferDetails"
                                            class="dgs-new-button" style="width: 40px; min-width: unset !important">
                                            <span v-if="collapseTransferDetails" class="arrow-down"></span>
                                            <span v-else class="arrow-up"></span>
                                        </v-btn>
                                    </div>
                                </div>
                                <v-divider v-if="!collapseTransferDetails"></v-divider>
                                <div :style="{ display: collapseTransferDetails ? 'none':'block' }">
                                    <div class="bg-color-buble">
                                        <div class="sender-receiver-box">
                                            <div>
                                                <span class="action-label-new">{{ $t("res_Label_Purpose") }}</span>
                                                <p class="main-text-large m-0">{{ this.document.purpose }}</p>
                                            </div>
                                            <div class="text-end">
                                                <span class="action-label-new">{{ $t('res_Label_TransferDate') }}</span>
                                                <p class="main-text-large m-0">{{ this.document.transferCreatedDate }}
                                                </p>
                                            </div>
                                        </div>
                                        <div class="sender-receiver-box">
                                            <div>
                                                <span class="action-label-new">{{ $t("res_GridHeaders_FromStructure")
                                                    }}</span>
                                                <p class="main-text-large m-0">{{ this.document.fromStructure }}</p>
                                            </div>
                                            <div class="text-end" v-if="this.document.isDispatched != true">
                                                <span class="action-label-new">{{ $t('res_GridHeaders_FromUser')
                                                    }}</span>
                                                <p class="main-text-large m-0">{{ this.document.fromUser }}</p>
                                            </div>
                                        </div>
                                        <div class="sender-receiver-box">
                                            <div>
                                                <span class="action-label-new">{{ $t("res_Label_Instruction") }}</span>
                                                <p class="main-text-large m-0">{{ this.document.instruction }}</p>
                                            </div>
                                        </div>
                                        <div class="sender-receiver-box">
                                            <div>
                                                <span class="action-label-new">{{ $t("res_Label_DueDate") }}</span>
                                                <p class="main-text-large m-0">{{ this.document.transferDueDate }}</p>
                                            </div>
                                            <div class="text-end">
                                                <span class="action-label-new">{{ $t('res_Label_ReferencenNo') }}</span>
                                                <p class="main-text-large m-0 text-truncate">{{
                                                    this.document.referenceNumber }} </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- hna changes -->
                            <!-- controls in create mode  v-if="canEditDocumentMetaData()" -->
                            <div class="inner-single-component">
                                <div class="form-sub-section attachments-section view-mode">
                                <div style="max-height: 60px">
                                    <v-row>
                                    <div class="d-flex justify-content-between align-items-center col">
                                        <h3 class="main-text-large mb-0 ml-2 mr-2">{{$t("res_GridHeaders_Details")}}</h3>
                                        <v-btn @click="collapseDetails = !collapseDetails" class="dgs-new-button"
                                            style="width: 40px; min-width: unset !important">
                                            <span v-if="collapseDetails" class="arrow-down"></span>
                                            <span v-else class="arrow-up"></span>
                                        </v-btn>
                                    </div>
                                    </v-row>
                                </div>
                            </div>
                                <v-divider v-if="!collapseDetails"></v-divider>
                                <div class="row" :style="{ display: collapseDetails ? 'none':'block' }">
                                    <div class="col-md-12" v-if="showRegisterFrom && user_structures.length > 1"
                                        style="display: block">
                                        <label>{{ $t("res_Label_RegisterFrom") }}</label>
                                        <div class="with-absolute-button">
                                            <multi-select class="light-bg" v-model="user_structure"
                                                label="structureName" track-by="structureId" open-direction="bottom"
                                                :options="user_structures" :searchable="true" :loading="loading"
                                                :internal-search="false" :clear-on-select="false"
                                                :close-on-select="true" :options-limit="300" :max-height="600"
                                                :disabled="!canEditDocumentMetaData()" :show-no-results="false"
                                                :hide-selected="false" :multiple="false"
                                                :placeholder="$t('res_Label_SelectOption')">
                                                <template `slot="noOptions" slot-scope="props">
                                                    {{ $t("res_Msgs_EmptySearch") }}
                                                </template>
                                            </multi-select>
                                        </div>
                                    </div>
                                    <!--Designated Persons Conponent-->
                                    <RecipientSenderSelector :sendingEntityId="document.sendingEntityId"
                                        :isDisabled="!canEditDocumentMetaData() || this.document.categoryId == 4 || this.document.categoryId == 5"
                                        :senderDesignatedPersonsId="document.sendingDesignatedPersonId"
                                        :receiversAndDesignatedPersons="document.receiversAndDesignatedPersons"
                                        :categoryId="this.document.categoryId"
                                        @exportedData="fillSenderRecipientDesignatedPersonsData"
                                        :currentStructureId="this.user_structure.structureId"
                                        :clearInputs="clearRecipientSenderSelectorInputs"
                                        :isDocumentSigned="document.isSigned"
                                        :documentId="documentId">
                                    </RecipientSenderSelector>
                                    <div class="col-md-12 label-control pl-3 pr-3"
                                        v-if="![10,1,4,5].includes(this.document.categoryId)">
                                        <label class="label_required">{{ $t("res_Label_CC") }}</label>
                                        <div class="with-absolute-button">
                                            <StructureUserSelector :showInternalUsers="true" :showExternalUsers="false"
                                                :showInternalStructures="true" :disabled="!canEditDocumentMetaData()"
                                                :showExternalStructures="false" :excludeSelf="true" :isMultiple="true"
                                                :selectedStructureUsersList="document.cc"
                                                @structureUserSelectChanged="documentCCSelectedChange">
                                            </StructureUserSelector>
                                        </div>
                                    </div>
                                    <div class="col-md-12 label-control pl-3 pr-3"
                                        v-if="this.document.categoryId == 10">
                                        <label class="label_required">{{ $t("res_Label_RequistingDepartment") }}
                                            *</label>
                                        <div class="with-absolute-button">
                                            <StructureUserSelector :showInternalUsers="false" :showExternalUsers="false"
                                                :showInternalStructures="true" :disabled="!canEditDocumentMetaData()"
                                                :showExternalStructures="false" :excludeSelf="true" :isMultiple="false"
                                                :selectedStructureUser="document.requestingDepatment"
                                                @structureUserSelectChanged="documentRequestingSelectedChange">
                                            </StructureUserSelector>
                                        </div>
                                    </div>
                                    <div class="col-12 label-control pl-3 pr-4" v-if="this.document.categoryId == 10">
                                        <label class="label_required">{{ $t("res_Label_Amount")}} *</label>
                                        <v-text-field v-model="document.amount" label="" solo
                                            :disabled="!canEditDocumentMetaData()"></v-text-field>
                                    </div>
                                    <div class="col-sm-12 label-control pl-3 pr-3"
                                        v-if="this.document.categoryId != 10 && this.document.categoryId != 4 && this.document.categoryId != 5">
                                        <label>{{ $t("res_Label_Priority") }} *</label>
                                        <div class="with-absolute-button">
                                            <multi-select class="light-bg" v-model="document.priority"
                                                :label="selectedLang == 'en' ? 'name': 'nameAr'" track-by="id"
                                                :disabled="!canEditDocumentMetaData()" open-direction="bottom"
                                                :options="priority_items" :searchable="true" :loading="loading"
                                                :internal-search="false" :clear-on-select="false"
                                                :close-on-select="true" :options-limit="300" :max-height="600"
                                                :show-no-results="false" :hide-selected="false" :multiple="false"
                                                @select="priorityChanged" ref="multiselect1"
                                                :placeholder="$t('res_Label_SelectOption')">
                                            </multi-select>
                                            <button
                                                @click="openMultiSelectCtrl(1)"><v-icon>mdi-menu-down</v-icon></button>
                                        </div>
                                    </div>
                                    <div class="col-sm-12 label-control pl-3 pr-3">
                                        <label>{{ $t("res_Label_Privacy") }} *</label>
                                        <div class="with-absolute-button">
                                            <multi-select class="light-bg" v-model="document.privacy"
                                                :label="selectedLang == 'en' ? 'name': 'nameAr'" track-by="id"
                                                :disabled="!canEditDocumentMetaData()" open-direction="bottom"
                                                :options="privacy_items" :searchable="true" :loading="loading"
                                                :internal-search="false" :clear-on-select="false"
                                                :close-on-select="true" :options-limit="300" :max-height="600"
                                                :show-no-results="false" :hide-selected="false" :multiple="false"
                                                ref="multiselect2" :placeholder="$t('res_Label_SelectOption')">
                                            </multi-select>
                                            <button
                                                @click="openMultiSelectCtrl(2)"><v-icon>mdi-menu-down</v-icon></button>
                                        </div>
                                    </div>
                                    <!-- <v-banner v-if="shouldShowPublicPrivacyBanner" icon="mdi-information" outlined
                                        class="p-0 my-2">
                                        <span>{{ $t("res_Msgs_PublicPrivacyBanner") }}</span>
                                    </v-banner> -->
                                    <div class="col-sm-12 label-control pl-3 pr-3"
                                        v-if="isImportanceFieldVisible && this.document.categoryId != 10 && this.document.categoryId != 4 && this.document.categoryId != 5">
                                        <label>{{ $t("res_Label_Importance") }}</label>
                                        <div class="with-absolute-button">
                                            <multi-select class="light-bg" v-model="document.importance"
                                                :label="selectedLang == 'en' ? 'name': 'nameAr'" track-by="id"
                                                :disabled="!canEditDocumentMetaData()" open-direction="bottom"
                                                :options="importance_items" :searchable="true" :loading="loading"
                                                :internal-search="false" :clear-on-select="false"
                                                :close-on-select="true" :options-limit="300" :max-height="600"
                                                :show-no-results="false" :hide-selected="false" :multiple="false"
                                                ref="multiselect3" :placeholder="$t('res_Label_SelectOption')">
                                            </multi-select>
                                            <button
                                                @click="openMultiSelectCtrl(3)"><v-icon>mdi-menu-down</v-icon></button>
                                        </div>
                                    </div>
                                    <div class="col-sm-12 label-control pl-3 pr-3"
                                        v-if="constants.showDocumentType && this.document.categoryId != 10">
                                        <label>{{ $t("DocumentType") }} *</label>
                                        <div class="with-absolute-button">
                                            <multi-select class="light-bg" v-model="document.documentType" label="name"
                                                track-by="id" :disabled="canEditDocumentMetaData()"
                                                open-direction="bottom" :options="documentType_items" :searchable="true"
                                                :loading="loading" :internal-search="false" :clear-on-select="false"
                                                :close-on-select="true" :options-limit="300" :max-height="600"
                                                :show-no-results="false" :hide-selected="false" :multiple="false"
                                                ref="multiselect21" :placeholder="$t('res_Label_SelectOption')">
                                            </multi-select>
                                            <button
                                                @click="openMultiSelectCtrl(21)"><v-icon>mdi-menu-down</v-icon></button>
                                        </div>
                                    </div>
                                    <div class="col-12 label-control pl-3 pr-4" v-if="this.document.categoryId == 1">
                                        <label class="label_required">{{ $t("res_Label_DocumentNumber") }}
                                            *</label>
                                        <v-text-field v-model="document.externalReferenceNumber" label="" solo
                                            :disabled="!canEditDocumentMetaData()"></v-text-field>
                                    </div>
                                    <div class="col-sm-12 label-control pl-3 pr-3"
                                        v-if="this.document.categoryId != 10">
                                        <label class="label_required">{{ $t("res_Label_DocumentDate") }} *</label>
                                        <v-menu content-class="p-0" v-model="document_date_menu"
                                            :close-on-content-click="false" :nudge-right="40"
                                            transition="scale-transition" offset-y min-width="auto"
                                            :disabled="!canEditDocumentMetaData() || this.document.categoryId == 4 || this.document.categoryId == 5">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field v-model="formattedDate" :label="$t('res_Label_SelectDate')" readonly v-bind="attrs"
                                                    v-on="on" solo append-icon="mdi-calendar" :tabindex="-1"
                                                    :disabled="canEditDocumentMetaData()">
                                                    <template v-slot:append>
                                                        <v-icon v-bind="attrs" v-on="on">mdi-calendar</v-icon>
                                                    </template>
                                                </v-text-field>
                                            </template>
                                            <v-date-picker v-model="document.date" @input="document_date_menu = false"
                                                :locale="selectedLang" :max="nowDate"
                                                :readonly="!canEditDocumentMetaData()"></v-date-picker>
                                        </v-menu>
                                    </div>

                                    <div class="col-sm-12 label-control pl-3 pr-3"
                                        v-if="viewIncomingAddedFields && this.document.categoryId != 10">
                                        <label class="label_required">{{ $t("res_Label_ReceivedDate") }}</label>
                                        <v-menu content-class="p-0" v-model="document_receivedDate_menu"
                                            :close-on-content-click="false" :nudge-right="40"
                                            transition="scale-transition" offset-y min-width="auto"
                                            :disabled="!canEditDocumentMetaData()">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field v-model="formattedReceivedDate" :label="$t('res_Label_SelectDate')" readonly
                                                    v-bind="attrs" v-on="on" solo append-icon="mdi-calendar" :tabindex="-1">
                                                    <template v-slot:append>
                                                        <v-icon v-bind="attrs" v-on="on">mdi-calendar</v-icon>
                                                    </template>
                                                </v-text-field>
                                            </template>
                                            <v-date-picker :locale="selectedLang" :max="nowDate"
                                                v-model="document.receivedDate"
                                                @input="document_receivedDate_menu = false"
                                                :readonly="!canEditDocumentMetaData()"></v-date-picker>
                                        </v-menu>
                                    </div>

                                    <div class="col-sm-12 label-control pl-3 pr-3 mb-4" v-if="false">
                                        <label class="label_required">{{ $t("res_Label_PrintingOptions") }}</label>
                                        <v-radio-group class="bg-white mt-0" v-model="multiDocument"
                                            style="height: 33px; padding-right: 35px;"
                                            :disabled="!canEditDocumentMetaData()">
                                            <div class="row" style="background-color: white">
                                                <div class="col-sm-6 pb-0" style="height: 35px;">
                                                    <v-radio :label="PrintingOptionsMultiplelbl" value="1"></v-radio>
                                                </div>
                                                <div class="col-sm-6 pb-0" style="height: 35px;">
                                                    <v-radio :label="PrintingOptionsSinglelbl" value="0"
                                                        selected></v-radio>
                                                </div>
                                            </div>
                                        </v-radio-group>
                                    </div>

                                    <div class="col-sm-12 label-control pl-3 pr-3" v-if="!hideMessageType">
                                        <label class="label_required">{{ $t("res_Label_MessageType") }}</label>
                                        <multi-select class="light-bg" v-model="document.messageType"
                                            :label="selectedLang == 'en' ? 'Name' : 'NameAr'" track-by="Id"
                                            :disabled="canEditDocumentMetaData()" open-direction="bottom"
                                            :options="messageType_items" :searchable="true" :loading="loading"
                                            :internal-search="false" :clear-on-select="false" :close-on-select="true"
                                            :options-limit="300" :max-height="600" :show-no-results="false"
                                            :hide-selected="false" :multiple="false" ref="multiselect22"
                                            :placeholder="$t('res_Label_MessageType')">
                                        </multi-select>
                                    </div>

                                    <div class="col-sm-12 label-control pl-3 pr-3" v-if="this.document.categoryId !=10">
                                        <label class="label_required">{{ $t("res_Label_DueDate") }} *</label>
                                        <v-menu content-class="p-0" v-model="document_due_date_menu"
                                            :close-on-content-click="false" :nudge-right="40"
                                            transition="scale-transition" offset-y min-width="auto"
                                            :disabled="!canEditDocumentMetaData() || this.document.categoryId == 4 || this.document.categoryId == 5">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field v-model="formattedDueDate" :label="$t('res_Label_SelectDate')" readonly
                                                    v-bind="attrs" v-on="on" solo append-icon="mdi-calendar" :tabindex="-1">
                                                    <template v-slot:append>
                                                        <v-icon v-bind="attrs" v-on="on">mdi-calendar</v-icon>
                                                    </template>
                                                </v-text-field>
                                            </template>
                                            <v-date-picker :locale="selectedLang" v-model="document.dueDate"
                                                @input="document_due_date_menu = false" :min="nowDate"
                                                :readonly="!canEditDocumentMetaData()"></v-date-picker>
                                        </v-menu>
                                    </div>
                                    <div class="col-sm-12 label-control pl-3 pr-3" v-if="areTagsEnabled && 
                                            constants.userActions.features.some(x=>x.name.toLowerCase() == constants.actionsEnum.features.DocumentTags.key)
                                            && this.document.categoryId != 4 && this.document.categoryId != 5">
                                        <label>{{ $t("res_Label_Tags") }}</label>
                                        <multi-select class="light-bg" v-model="document.tags" label="name"
                                            track-by="id" open-direction="bottom" :options="tagOptions"
                                            :disabled="!canEditDocumentMetaData()" :searchable="true" :loading="loading"
                                            :clear-on-select="false" @search-change="searchTags"
                                            :close-on-select="false" :options-limit="300" :max-height="600"
                                            :show-no-results="false" :hide-selected="false" :multiple="true"
                                            :taggable="true" @tag="addTag" ref="multiselect5"
                                            :placeholder="$t('res_Label_SelectOption')">
                                            <template slot="noOptions">
                                                {{ $t('res_Label_ListEmpty') }}
                                            </template>
                                        </multi-select>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="d-flex justify-content-between align-items-center">
                                            <div>
                                                <label class="label_required">{{ $t("res_Label_Subject") }} *</label>
                                            </div>
                                            <div class="text-center position-relative">
                                                <v-menu offset-y :close-on-content-click="false" attach
                                                    :left="!$vuetify.rtl" :right="$vuetify.rtl"
                                                    class="white-background">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <button class="more-list d-flex align-items-center"
                                                            v-bind="attrs" v-on="on">
                                                            {{ $t("res_ButtonText_More") }} <v-icon
                                                                class="light">mdi-chevron-down</v-icon>
                                                        </button>
                                                    </template>
                                                    <v-list class="checkbox-select-list" dense>
                                                        <!-- <v-list-item>
                                                            <v-list-item-title>
                                                                <v-checkbox v-model="showTranslatedSubjectBlock"
                                                                    :label="TranslatedSubjectLabel"
                                                                    class="bg-white"></v-checkbox>
                                                            </v-list-item-title>
                                                        </v-list-item> -->
                                                        <v-list-item>
                                                            <v-list-item-title>
                                                                <v-checkbox v-model="showCommentsBlock"
                                                                    :label="CommentsLabel"></v-checkbox>
                                                            </v-list-item-title>
                                                        </v-list-item>
                                                        <v-list-item>
                                                            <v-list-item-title>
                                                                <v-checkbox v-model="showOtherAttachmentsBlock"
                                                                    :label="OtherAttachmentsLabel"></v-checkbox>
                                                            </v-list-item-title>
                                                        </v-list-item>
                                                        <v-divider></v-divider>
                                                        <v-list-item>
                                                            <a class="clear-btn" @click="clearBlockSelections()">{{
                                                                $t("res_ButtonText_Clear") }}</a>
                                                        </v-list-item>
                                                    </v-list>
                                                </v-menu>
                                            </div>
                                        </div>
                                        <v-textarea v-model="document.subject" label="" rows="2"
                                            class="light-bg subject-txt" :placeholder="$t('res_Label_defaultTextValue')"
                                            :disabled="!canEditDocumentMetaData()"></v-textarea>
                                    </div>

                                    <!-- <div class="col-md-12 label-control pl-3 pr-3"
                                        v-if="showTranslatedSubjectBlock && this.document.categoryId !=10 && this.document.categoryId != 4 && this.document.categoryId != 5">
                                        <label>{{ $t("res_Label_TranslatedSubject") }}</label>
                                        <v-textarea v-model="document.translatedSubject" label="" rows=2
                                            class="light-bg" :placeholder="$t('res_Label_defaultTextValue')"
                                            :disabled="!canEditDocumentMetaData()"></v-textarea>
                                    </div> -->
                                    <template
                                        v-if="constants.showFilingClassificationPlanSections && this.document.categoryId != 10">
                                        <div class="col-md-12 label-control pl-3 pr-5">
                                            <label>{{ $t("res_label_FilingPlan") }}</label>
                                            <div class="with-absolute-button">
                                                <FilingClassificationPlanSelector
                                                    :mode="filingClassificationPlanMode.FilingPlanMode"
                                                    :selectedFilingPlan="document.filingPlan"
                                                    @FilingPlanSelectChanged="filingPlanSelectChanged"
                                                    :disabled="!canEditDocumentMetaData()">
                                                </FilingClassificationPlanSelector>
                                            </div>
                                        </div>
                                        <div class="col-md-12 label-control pl-3 pr-5">
                                            <label>{{ $t("res_label_ClassificationPlan") }}{{
                                                classificationPlanIdRequired ?'*':'' }}</label>
                                            <div class="with-absolute-button">
                                                <FilingClassificationPlanSelector
                                                    :mode="filingClassificationPlanMode.ClassificationPlanMode"
                                                    :disabled="!canEditDocumentMetaData()"
                                                    :selectedClassificationPlan="document.classificationPlan"
                                                    @ClassificationPlanSelectChanged="classificationPlanSelectChanged">
                                                </FilingClassificationPlanSelector>
                                            </div>
                                        </div>
                                    </template>

                                    <template v-if="constants.showReplyNeedReply && this.document.categoryId != 10">
                                        <span class="col-md-12 d-flex align-items-center"
                                            v-if="this.document.categoryId == 2">
                                            <v-checkbox v-model="document.isNeedReply" class="mt-1"
                                                :disabled="!canEditDocumentMetaData()"></v-checkbox>
                                            <span class="">{{ $t("res_Label_NeedReply") }}</span>
                                        </span>
                                        <template v-if="![10,1].includes(this.document.categoryId)">
                                            <span class="d-flex align-items-center">
                                                <v-checkbox v-model="showReplyDocumentSection"
                                                    @click="handleShowReplyDocumentSection" class="mt-1"></v-checkbox>
                                                <span class="">{{ $t("res_Label_Reply") }}</span>
                                            </span>
                                            <div class="col-md-12 mb-0 mb-3"
                                                v-if="showReplyDocumentSection && this.document.categoryId !=10">
                                                <div class="d-flex align-items-center">
                                                    <div class="with-absolute-button flex-1">
                                                        <DocumentSelector :selectedDocument="document.replyDocument"
                                                            @DocumentSelectChange="replyDocumentSelectedChange">
                                                        </DocumentSelector>
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                    </template>

                                    <!-- <div class="col-md-12"
                                        v-if="constants.client_version_Id == 'DDA' && constants.categories_has_configure_signature.indexOf(this.document.categoryId) == -1 && selectedTemplate == null">
                                        <label class="label_required">{{ $t("res_Label_SendAfterSigne") }}</label>
                                        <div class="d-flex align-items-center">
                                            <div class="with-absolute-button flex-1">
                                                <StructureUserSelector :showInternalUsers="true"
                                                    :showExternalUsers="false" :showInternalStructures="true"
                                                    :showExternalStructures="false" :excludeSelf="true"
                                                    :isMultiple="true"
                                                    :selectedStructureUsersList="document.send_after_sign"
                                                    @structureUserSelectChanged="documentSendAfterSignSelectedChange">
                                                </StructureUserSelector>
                                            </div>
                                        </div>
                                    </div> -->

                                    <div class="col-md-12 label-control pl-3 pr-3"
                                        v-if="showCommentsBlock && this.document.categoryId !=10 && this.document.categoryId != 4 && this.document.categoryId != 5">
                                        <label>{{ $t("res_Label_Keywords") }}</label>
                                        <v-textarea v-model="document.keywords" label="" rows="1" class="light-bg"
                                            :placeholder="$t('res_Label_defaultTextValue')"
                                            :disabled="!canEditDocumentMetaData()"></v-textarea>
                                    </div>
                                    <div class="col-md-12 label-control pl-3 pr-3"
                                        v-if="showOtherAttachmentsBlock && this.document.categoryId !=10 && this.document.categoryId != 4 && this.document.categoryId != 5">
                                        <label>{{ $t("res_Label_OtherAttachments") }}</label>
                                        <v-textarea v-model="document.otherAttachments" label="" rows="1"
                                            class="light-bg" :placeholder="$t('res_Label_defaultTextValue')"
                                            :disabled="!canEditDocumentMetaData()"></v-textarea>
                                    </div>
                                    <!-- <div class="col-md-12 label-control pl-3 pr-3"
                                        v-if="constants.client_version_Id == 'AdPorts' && this.document.categoryId !=10">
                                        <label>{{ $t("res_Label_Employee") }}</label>
                                        <div class="with-absolute-button">
                                            <multi-select class="light-bg" v-model="document.hrmsEmployee" track-by="id"
                                                label="name" open-direction="bottom"
                                                :options="constants.hrmsEmployeeList" :searchable="true"
                                                :loading="loading" :internal-search="true" :clear-on-select="false"
                                                :close-on-select="true" :options-limit="300" :max-height="600"
                                                :show-no-results="false" :hide-selected="false" :multiple="false"
                                                ref="multiselect15" :placeholder="$t('res_Label_SelectOption')"
                                                :disabled="!canEditDocumentMetaData()">
                                            </multi-select>
                                            <button
                                                @click="openMultiSelectCtrl(15)"><v-icon>mdi-menu-down</v-icon></button>
                                        </div>
                                    </div> -->
                                </div>
                            </div>

                            <!--signee-->
                            <div class=" inner-single-component"
                                v-if="canEditDocumentMetaData() && (( this.document.categoryId == 3 && selectedTemplate !== null && selectedTemplate.isWorkflow == true ) || 
                                ( selectedTemplate == null && constants.categories_has_configure_signature.indexOf(this.document.categoryId) == -1))">
                                <div class="form-sub-section"
                                    v-if="canEditDocumentMetaData() && ((this.document.categoryId == 3 && selectedTemplate !== null && selectedTemplate.isWorkflow == true) || (selectedTemplate == null && (constants.client_version_Id == 'AdPorts'|| constants.client_version_Id == 'UAEU' || constants.client_version_Id == 'DOPA' || constants.client_version_Id == 'DEG')))">
                                    <div class="d-flex justify-content-between align-items-center">
                                        <div class="margin-right-auto">
                                            <h3 class="main-text-large">{{ $t("res_Label_Signees") }}</h3>
                                        </div>
                                        <v-btn
                                            v-if="selectedTemplate == null"
                                            class="dgs-new-button ml-2 mr-2" @click="addNewSignee">{{$t('Add')}}</v-btn>
                                        <v-btn @click="collapseSigners = !collapseSigners" class="dgs-new-button"
                                            style="width: 40px; min-width: unset !important">
                                            <span v-if="collapseSigners" class="arrow-down"></span>
                                            <span v-else class="arrow-up"></span>
                                        </v-btn>
                                    </div>
                                    <v-divider v-if="!collapseSigners && this.document.signers.length > 0"></v-divider>
                                    <Container drag-handle-selector=".column-drag-handle" drag-class="opacity-ghost"
                                        @drop="signeesOnDrop" :style="{ display: collapseSigners ? 'none':'block' }">
                                        <Draggable class="col-md-12 p-0" v-for="(item, index) in this.document.signers"
                                            :key="index" drag-handle-selector=".column-drag-handle">
                                            <label class="label_required" style="cursor:pointer">{{
                                                $t("res_Label_Signee") }} {{ index + 1 }} *</label>
                                            <div class="d-flex align-items-center column-drag-handle">
                                                <v-icon style="bottom: 10px;cursor:pointer;">mdi-dots-vertical</v-icon>
                                                <div class="with-absolute-button flex-1" style="padding-bottom: 20px;">
                                                    <StructureUserSelector :showInternalUsers="true"
                                                        :showExternalUsers="false" :showInternalStructures="false"
                                                        :showExternalStructures="false" :excludeSelf="false"
                                                        :isMultiple="false" :isForSignee="true"
                                                        :selectedStructureUser="item.index && !item.id ? undefined : item"
                                                        :dataToPassOnSelectChange="index"
                                                        @structureUserSelectChanged="documentSigneeSelectedChange"
                                                        :addressBook_header="$t('res_Label_SelectSignee')">
                                                    </StructureUserSelector>
                                                </div>                     
                                            </div>
                                        </Draggable>
                                    </Container>
                                </div>
                            </div>
                        </div>

                        <br />
                        <!-- attachments -->
                        <div class=" inner-single-component">
                            <div class="form-sub-section attachments-section"
                                v-bind:class="{ 'view-mode': !canAddEditAttachments('edit') }">
                                <div style="max-height: 60px">
                                    <v-row>
                                        <v-col class="d-flex justify-content-between align-items-center">
                                            <span class="margin-right-auto">
                                                <h3 class="main-text-large">{{ $t("res_CardHeaders_Attachments") }}</h3>
                                            </span>

                                            <v-menu v-if="canAddEditAttachments('add')" v-model="isMenuOpen"
                                                :close-on-content-click="false" transition="slide-y-transition"
                                                offset-y>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn v-bind="attrs" v-on="on" class="dgs-new-button ml-2 mr-2">
                                                        <div class="d-flex align-center">
                                                            <span>{{ $t("res_ButtonText_Upload_Scan") }}</span>
                                                            <span v-if="!isMenuOpen" class="arrow-down ml-1"></span>
                                                            <span v-else class="arrow-up ml-1"></span>
                                                        </div>
                                                    </v-btn>
                                                </template>

                                                <v-list>
                                                    <v-list-item @click="performAction('Upload')">
                                                        <v-list-item-title>{{ $t("res_ButtonText_Upload")
                                                            }}</v-list-item-title>
                                                    </v-list-item>
                                                    <v-list-item @click="performAction('Scan')">
                                                        <v-list-item-title>{{ $t("res_Label_Scan")
                                                            }}</v-list-item-title>
                                                    </v-list-item>
                                                </v-list>
                                            </v-menu>

                                            <v-btn @click="collapseAttachments = !collapseAttachments" class="dgs-new-button" style="width: 40px; min-width: unset !important">
                                                <span v-if="collapseAttachments" class="arrow-down"></span>
                                                <span v-else class="arrow-up"></span>
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                </div>
                                <v-divider v-if="!collapseAttachments"></v-divider>
                                <div :style="{ display: collapseAttachments ? 'none':'block' }">
                                    <Attachments ref="attachmentCtrl" :documentId="documentId" :transferId="transferId"
                                        :documentSubject="document.subject"
                                        @attachmentExtensionChanged="attachmentExtensionChanged"
                                        :viewMode="canAddEditAttachments('edit') ? 'edit' : 'readonly'"
                                        :categoryId="document.categoryId" :nodeId="openedFromNodeId"
                                        @reloadDocument="reloadDocument" :document="document"
                                        :delegationId="delegationId" @setViewerUrl="setViewerUrl"
                                        :showConfigureSignatures="showConfigureSignatures"
                                        :referenceSequenceType="document.referenceSequenceType"></Attachments>
                                </div>
                            </div>
                        </div>

                        <br />
                        <!-- notes -->
                        <div class="inner-single-component">
                            <Notes :documentId="documentId" :transferId="transferId"
                                :viewMode="canAddEditNotes() ? 'edit' : 'readonly'"></Notes>
                        </div>

                        <br />
                        <!--Linked mails-->
                        <div class="inner-single-component">
                            <div class="form-sub-section linked-mails-section" style="display: block">
                                <div class="d-flex main-text-large justify-content-between">
                                    <span class="margin-right-auto">
                                        <h3>{{ $t("res_CardHeaders_LinkedEmails") }}</h3>
                                    </span>
                                    <v-btn class="dgs-new-button ml-2 mr-2" @click="addLinkedDocuments"
                                        v-if="canAddEditLinkedDocuments()">{{ $t("res_ButtonText_Add")}}</v-btn>
                                    <v-btn @click="collapseLinkedDocuments = !collapseLinkedDocuments"
                                        class="dgs-new-button" style="width: 40px; min-width: unset !important">
                                        <span v-if="collapseLinkedDocuments" class="arrow-down"></span>
                                        <span v-else class="arrow-up"></span>
                                    </v-btn>
                                </div>
                                <v-divider
                                    v-if="!collapseLinkedDocuments && linkedDocumentsFullList.length > 0"></v-divider>
                                <div v-bind:class="{ 'with-view-all' : linkedDocumentsFullList.length > defaultNumberOfLinkedDocumentsToDisplay }"
                                    :style="{ display: collapseLinkedDocuments ? 'none':'block' }">
                                    <v-list>
                                        <v-list-item class="text-hover-list" v-for="(item, i) in linkedDocuments"
                                            :key="i" @dblclick="displayLinkedItem(item)">
                                            <div class="d-flex justify-content-between align-items-center w-100">
                                                <v-list-item-content>
                                                    <v-list-item-title>
                                                        <div class="d-flex flex-row align-items-center">
                                                            <div
                                                                class="subject flex-1 overflow-hidden text-nowrap overflow-ellipsis">
                                                                {{ item.subject }}
                                                            </div>
                                                        </div>
                                                    </v-list-item-title>
                                                    <v-list-item-title>
                                                        <div class="d-flex flex-row align-items-center">
                                                            <div slot-scope=""
                                                                class="reference flex-1 overflow-hidden text-nowrap overflow-ellipsis">
                                                                {{ item.referenceNumber }}
                                                            </div>
                                                        </div>
                                                    </v-list-item-title>
                                                    <v-list-item-subtitle>
                                                        <div
                                                            class="uploaded-by overflow-hidden text-nowrap overflow-ellipsis">
                                                            {{ $t("res_SubTitle_UploadedBy") }} {{ item.createdByUser }}
                                                        </div>
                                                    </v-list-item-subtitle>
                                                </v-list-item-content>
                                                <div class="created-date">
                                                    {{ utils.formatDateTime(item.createdDate) }}
                                                </div>
                                                <div class="custom-icon-wrapper">
                                                    <v-icon @click="openLinkedEmailDeleteConfirmation(item.id)"
                                                        v-if="canAddEditLinkedDocuments() && item.isEditable">custom-icon
                                                        white-bg delete-icon</v-icon>
                                                </div>
                                            </div>
                                        </v-list-item>
                                    </v-list>

                                    <v-divider class="view-all-divider"
                                        v-if="linkedDocumentsFullList.length > defaultNumberOfLinkedDocumentsToDisplay"></v-divider>
                                    <div class="view-all-wrapper d-flex justify-content-center align-content-center"
                                        v-if="linkedDocumentsFullList.length > defaultNumberOfLinkedDocumentsToDisplay">
                                        <button class="view-all-btn d-flex align-items-center"
                                            @click="viewAllLinkedDocuments()"
                                            v-if="numberOfLinkedDocumentsToDisplay != 1000">
                                            {{ $t("res_ButtonText_ViewAll") }} <v-icon
                                                class="light">mdi-chevron-down</v-icon>
                                        </button>
                                        <button class="view-all-btn d-flex align-items-center"
                                            @click="viewAllLinkedDocuments()"
                                            v-if="numberOfLinkedDocumentsToDisplay == 1000">
                                            {{ $t("res_ButtonText_ShowLess") }} <v-icon
                                                class="light">mdi-chevron-up</v-icon>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <br />
                        <!-- Transfers -->
                        <div class="inner-single-component" v-if="this.transferId > 0">
                            <TransferList :documentId="documentId" :toUserId="toUserId" v-if="this.transferId != 0"
                                :delegationId="delegationId" @getTransferNotesCount="getTransferNotesCount"></TransferList>
                        </div>

                        <br />
                        <!-- Dispatch Info -->
                        <div class="inner-single-component"
                            v-if="this.transferId > 0 && this.document.categoryId == 2">
                            <DispatchInfo :documentId="documentId" :nodeId="openedFromNodeId"
                                v-if="this.transferId > 0 && this.document.categoryId == 2">
                            </DispatchInfo>
                        </div>
                        <br />
                        <!-- Dispatch DocumentLetter -->
                        <div class="inner-single-component">
                            <DocumentDispatchLetter :documentId="documentId"></DocumentDispatchLetter>
                        </div>
                    </div>
                </div>

                <div class="viewer-wrapper col-12 h-100 p-0 m-0">
                    <!--viewer section-->
                    <div class="d-flex flex-column h-100">
                        <div class="p-0 scrollable-container flex-1 overflow-hidden">
                            <div v-if="empty_viewer" class="empty-viewer">
                                <img src="/assets/images/icons/no_preview.svg" />
                                <p class="mt-4 weight-400">{{ $t("res_Msgs_NoPreviewAvailable") }}</p>
                            </div>
                            <div v-if="!empty_viewer" id="viewer_template" class="h-100">
                                <iframe id="viewerFrame" :src="viewerFrameSrc" class="h-100 w-100"></iframe>
                            </div>
                        </div>

                        <!--Actions buttons-->
                        <div class="dialog-footer sticky-footer top-shadow p-3 d-flex align-items-center justify-content-between position-relative rowContainer"
                            >
                            <div class=" d-flex align-items-center justify-content-start">
                                <TransferNotesIcon  v-if="transferId != 0" :isSecretNote="isSecretNote" :toUserId="toUserId" :fromUserId="fromUserId" :loginUserId="loginUserId" ref="transferNotesIcon" :multipleTransferNotesExist="multipleTransferNotesExist"></TransferNotesIcon>
                                <!--Buttons Mode-->
                                <!-- ===================== Button Collection 1 =====================
                                     Toolbar buttons. Every button that carries a data-action-key
                                     participates in the overflow calculation: when it does not fit
                                     inside .rowContainer it gets the .action-overflowed class and its
                                     twin in Collection 2 (More Actions) is rendered instead.
                                     Anything WITHOUT a data-action-key is always visible.
                                ============================================================== -->
                                <div ref="actionsRow" class="d-flex margin-left-m actions-row">

                                    <v-menu
                                        v-if="startButtonRendering && utils.ActionsPermission('ForceGenerateReferenceNumber', document, transferId, delegationId , openedFromNodeId, document.canSign)"
                                        id="btnForceGenerateReferenceNumber"
                                        content-class="viewer-button align-bottom-left" top offset-y
                                        :close-on-content-click="true" :left="$vuetify.rtl" :right="!$vuetify.rtl">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn v-bind="attrs"
                                                data-action-key="btnForceGenerateReferenceNumber"
                                                :class="actionClass('btnForceGenerateReferenceNumber')"
                                                style="width:48px !important;height:40px !important;min-width:48px !important"
                                                v-on="on" class="ForceGenerateReferenceNumberBtn"
                                                v-tooltip="$t('res_Tooltip_GenerateReferenceNumber')">
                                                <v-icon style="color: #009639;">mdi-weather-lightning</v-icon>
                                            </v-btn>
                                        </template>
                                        <v-list class="actions_menu333">
                                            <v-list-item @click="forceGenerateReferenceNumber">{{
                                                $t("res_Tooltip_GenerateNormal") }}</v-list-item>
                                            <v-list-item @click="GetDocumentSigners"
                                                v-if="showAdvanceForceGenerateRF">{{ $t("res_Tooltip_GenerateAdvance")
                                                }}</v-list-item>
                                        </v-list>
                                    </v-menu>
                                    <!-- <v-btn class="light-blue" v-if="startButtonRendering && utils.ActionsPermission('PublishToMultiDocument', document, transferId, delegationId , openedFromNodeId)" id="Button2" @click="PublishToMultiDocument" v-tooltip="$t('res_ButtonText_PublishToMultiDocument')">
                                        <v-icon>mdi-publish</v-icon>&nbsp;
                                        {{ $t("res_ButtonText_PublishToMultiDocument") }}
                                    </v-btn> -->
                                    <v-btn class="light-success" :class="actionClass('btnResetDocument')"
                                        data-action-key="btnResetDocument"
                                        v-if="startButtonRendering && hasEditSignedPermissionRecord && utils.ActionsPermission('ResetDocument', document, transferId, delegationId, openedFromNodeId)"
                                        id="btnResetDocument" @click="resetDocument"
                                        v-tooltip="$t('res_Tooltip_ResetDocument')">
                                        <v-icon style="color: #009639;">mdi-backup-restore</v-icon>
                                    </v-btn>
                                    <v-btn class="light-blue ReviewBtn margin-left-m" :class="actionClass('Button3')"
                                        data-action-key="Button3"
                                        v-if="startButtonRendering && utils.ActionsPermission('Preview', document, transferId, delegationId , openedFromNodeId)"
                                        id="Button3" @click="previewSignature" v-tooltip="$t('res_CardHeaders_PreviewSignature')">
                                        <v-icon>mdi-eye-refresh-outline</v-icon>&nbsp;
                                        {{ $t("res_CardHeaders_PreviewSignature") }}
                                    </v-btn>
                                    <v-btn class="light-success margin-left-m" :class="actionClass('Button4')"
                                        data-action-key="Button4"
                                        v-if="startButtonRendering && utils.ActionsPermission('Sign', document, transferId, delegationId , openedFromNodeId, document.canSign)"
                                        id="Button4" @click="signDocument()" v-tooltip="$t('res_ButtonText_Sign')">
                                        <v-icon style="color: #009639;">mdi-account-edit-outline</v-icon>&nbsp;
                                        {{ $t("res_ButtonText_Sign") }}
                                    </v-btn>
                                    <v-btn class="light-blue margin-left-m" :class="actionClass('Button5')"
                                        data-action-key="Button5"
                                        v-if="startButtonRendering && utils.ActionsPermission('Complete', document, transferId, delegationId , openedFromNodeId)"
                                        id="Button5" @click="completeTransfers(transferId)">
                                        <v-icon>mdi-archive-cancel</v-icon>
                                        {{ $t('res_ButtonText_Complete') }}
                                    </v-btn>
                                    <v-btn class="light-blue margin-left-m" :class="actionClass('btnDisableQRCode')"
                                        data-action-key="btnDisableQRCode"
                                        v-if="startButtonRendering && utils.ActionsPermission('DisableQRCode', document, transferId, delegationId, openedFromNodeId)"
                                        id="btnDisableQRCode" @click="disableQrCode">
                                        <v-icon>mdi-qrcode</v-icon>&nbsp;
                                        {{ $t("res_ButtonText_DisableQRCode") }}
                                    </v-btn>
                                    <v-btn class="light-success margin-left-m" :class="actionClass('Button7')"
                                        data-action-key="Button7"
                                        v-if="startButtonRendering && utils.ActionsPermission('Approve', document, transferId, delegationId , openedFromNodeId)"
                                        id="Button7" @click="ApproveDocument" v-tooltip="$t('res_ButtonText_Approve')">
                                        <v-icon style="color: #009639;">mdi-account-edit-outline</v-icon>&nbsp;
                                        {{ $t("res_ButtonText_Approve") }}
                                    </v-btn>
                                    <v-btn class="light-success SignTransferBtn margin-left-m" :class="actionClass('Button8')"
                                        data-action-key="Button8"
                                        v-if="startButtonRendering && utils.ActionsPermission('SignAndSend', document, transferId, delegationId , openedFromNodeId, document.canSign)"
                                        id="Button8" @click="OpenTransferForm('Sign')"
                                        v-tooltip="$t('res_ButtonText_SignAndTransfer')">
                                        <v-icon style="color: #009639;">mdi-signature-freehand</v-icon>&nbsp;
                                        {{ $t("res_ButtonText_SignAndTransfer") }}
                                    </v-btn>
                                    <v-btn class="light-blue margin-left-m" :class="actionClass('Button6')"
                                        data-action-key="Button6"
                                        v-if="startButtonRendering && utils.ActionsPermission('DispatchCorrespondence', document, transferId, delegationId , openedFromNodeId)"
                                        id="Button6" @click="dispatchCorrespondence(false)"
                                        v-tooltip="$t('res_ButtonText_Dispatch')">
                                        <v-icon>mdi-send</v-icon>&nbsp;
                                        {{ $t("res_ButtonText_Dispatch") }}
                                    </v-btn>
                                    <v-btn class="light-blue margin-left-m" :class="actionClass('Button9')"
                                        data-action-key="Button9"
                                        v-if="startButtonRendering && utils.ActionsPermission('CreateReply', document, transferId, delegationId , openedFromNodeId)"
                                        id="Button9" @click="CreateReplyLetter" v-tooltip="$t('res_ButtonText_Reply')">
                                        <v-icon style="color: #009639;">mdi-reply</v-icon>&nbsp;
                                        {{ $t("res_ButtonText_Reply") }}
                                    </v-btn>
                                    <v-btn class="danger RejectBtn margin-left-m" :class="actionClass('Button10')"
                                        data-action-key="Button10"
                                        v-if="startButtonRendering && utils.ActionsPermission('Reject', document, transferId, delegationId , openedFromNodeId, document.canSign)"
                                        id="Button10" @click="OpenTransferForm('Rejected')"
                                        v-tooltip="$t('res_ButtonText_Reject')">
                                        <v-icon class="custom-icon">mdi-close-circle</v-icon>&nbsp;
                                        {{ $t("res_ButtonText_Reject") }}
                                    </v-btn>
                                    <v-btn class="light-blue TransferBtn margin-left-m" :class="actionClass('Button11')"
                                        data-action-key="Button11"
                                        v-if="startButtonRendering && utils.ActionsPermission('Forward', document, transferId, delegationId , openedFromNodeId)"
                                        id="Button11" @click="OpenTransferForm('Forward')"
                                        v-tooltip="$t('res_ButtonText_Forward')">
                                        <v-icon>mdi-share-outline</v-icon>
                                        {{ $t('res_ButtonText_Forward') }}
                                    </v-btn>

                                    <v-btn class="light-blue CreateCCBtn margin-left-m" :class="actionClass('Button12')"
                                        data-action-key="Button12"
                                        v-if="startButtonRendering && utils.ActionsPermission('ForwardCc', document, transferId, delegationId , openedFromNodeId)"
                                        id="Button12" @click="OpenTransferForm('ForwardCc')"
                                        v-tooltip="$t('res_MenuItems_ForwardCC')">
                                        <v-icon>mdi-share-outline</v-icon>
                                        {{ $t('res_MenuItems_ForwardCC') }}
                                    </v-btn>
                                    <v-btn class="light-blue EndorseBtn margin-left-m" :class="actionClass('Button13')"
                                        data-action-key="Button13"
                                        v-if="startButtonRendering && utils.ActionsPermission('Endorse', document, transferId, delegationId , openedFromNodeId)"
                                        id="Button13" @click="OpenTransferForm('Endorse')"
                                        v-tooltip="$t('res_ButtonText_Endorse')">
                                        <v-icon>mdi-email-plus-outline</v-icon>
                                        {{ $t('res_ButtonText_Endorse') }}
                                    </v-btn>
                                    <v-btn class="light-blue SendBackBtn margin-left-m" :class="actionClass('Button14')"
                                        data-action-key="Button14"
                                        v-if="startButtonRendering && utils.ActionsPermission('SendBack', document, transferId, delegationId , openedFromNodeId)"
                                        id="Button14" @click="OpenTransferForm('Send Back')"
                                        v-tooltip="$t('res_ButtonText_SendBack')">
                                        <v-icon>mdi-backburger</v-icon>
                                        {{ $t('res_ButtonText_SendBack') }}
                                    </v-btn>
                                    <v-btn class="light-blue ArchiveBtn margin-left-m" :class="actionClass('Button15')"
                                        data-action-key="Button15"
                                        v-if="utils.ActionsPermission('Archive', document, transferId, delegationId , openedFromNodeId) && !openFromManageCorrespondences"
                                        id="Button15" @click="openCompleteDocumentDialog()"
                                        v-tooltip="$t('res_ButtonText_Archive')">
                                        <v-icon>mdi-archive-outline</v-icon>
                                        {{ $t('res_ButtonText_Archive') }}
                                    </v-btn>
                                    <v-btn class="light-blue UndoArchiveBtn margin-left-m" :class="actionClass('Button16')"
                                        data-action-key="Button16"
                                        v-if="startButtonRendering && utils.ActionsPermission('UndoArchive', document, transferId, delegationId , openedFromNodeId)"
                                        id="Button16" @click="UndoArchive(document)">
                                        <v-icon>mdi-archive-cancel</v-icon>
                                        {{ $t('res_ButtonText_UndoArchive') }}
                                    </v-btn>
                                    <v-btn class="light-blue DismissSentBtn margin-left-m" :class="actionClass('Button17')"
                                        data-action-key="Button17"
                                        v-if="startButtonRendering && utils.ActionsPermission('DismissSent', document, transferId, delegationId , openedFromNodeId)"
                                        id="Button17" @click="dismissSent(transferId)">
                                        <!-- <v-icon>mdi-check-circle-outline</v-icon> -->
                                        {{ $t('res_MenuItems_Dismiss') }}
                                    </v-btn>
                                    <v-btn class="light-blue DismissCcedBtn margin-left-m" :class="actionClass('Button18')"
                                        data-action-key="Button18"
                                        v-if="startButtonRendering && utils.ActionsPermission('DismissCced', document, transferId, delegationId , openedFromNodeId)"
                                        id="Button18" @click="DismissCced(transferId)">
                                        <!-- <v-icon>mdi-check-circle-outline</v-icon> -->
                                        {{ $t('res_Label_CcedDismiss') }}
                                    </v-btn>
                                    <v-btn class="light-blue RecallBtn margin-left-m" :class="actionClass('Button19')"
                                        data-action-key="Button19"
                                        v-if="startButtonRendering && utils.ActionsPermission('Recall', document, transferId, delegationId , openedFromNodeId)"
                                        id="Button19" @click="recall()">
                                        {{ $t("res_MenuItems_Recall") }}
                                    </v-btn>
                                    <v-btn class="light-blue NotifyEmailBtn margin-left-m" :class="actionClass('Button20')"
                                        data-action-key="Button20" @click="notifyEmailCorrespondence(true)"
                                        v-if="startButtonRendering && utils.ActionsPermission('NotifyEmail', document, transferId, delegationId , openedFromNodeId)"
                                        id="Button20">
                                        {{ $t("res_MenuItems_NotifyEmail") }}
                                    </v-btn>
                                    <v-btn class="light-blue DeleteDraftBtn margin-left-m" :class="actionClass('btnDeleteDraft')"
                                        data-action-key="btnDeleteDraft"
                                        v-if="startButtonRendering && utils.ActionsPermission('DeleteDraft', document, transferId, delegationId , openedFromNodeId)"
                                        id="btnDeleteDraft" @click="deleteDraftDocument(document)" v-tooltip="$t('res_ButtonText_Delete')">
                                        <v-icon>mdi-delete</v-icon>&nbsp;
                                        {{ $t("res_ButtonText_Delete") }}
                                    </v-btn>
                                </div>
                                <!--More Actions Section-->
                                <v-menu v-if="document.isRegistered"
                                    content-class="viewer-button align-bottom-left" top offset-y
                                    :close-on-content-click="true" :left="$vuetify.rtl" :right="!$vuetify.rtl">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn v-bind="attrs" v-on="on" class="light-blue more-btn margin-left-m">
                                            <span>{{ $t("res_MenuItems_MoreActions") }}</span>
                                        </v-btn>
                                    </template>

                                    <v-list class="actions_menu333">
                                        <!-- ===================== Button Collection 2 =====================
                                             Text twins of the Collection 1 buttons. Each mirrored entry is
                                             rendered ONLY while its button is collapsed (isActionOverflowed),
                                             so an action is always reachable from exactly one of the two
                                             collections - never from neither, never from both.
                                        ============================================================== -->
                                        <v-list-item @click="forceGenerateReferenceNumber"
                                            v-if="startButtonRendering && utils.ActionsPermission('ForceGenerateReferenceNumber', document, transferId, delegationId , openedFromNodeId, document.canSign) && isActionOverflowed('btnForceGenerateReferenceNumber')">{{
                                            $t("res_Tooltip_GenerateNormal") }}</v-list-item>
                                        <v-list-item @click="GetDocumentSigners"
                                            v-if="startButtonRendering && showAdvanceForceGenerateRF && utils.ActionsPermission('ForceGenerateReferenceNumber', document, transferId, delegationId , openedFromNodeId, document.canSign) && isActionOverflowed('btnForceGenerateReferenceNumber')">{{
                                            $t("res_Tooltip_GenerateAdvance") }}</v-list-item>
                                        <v-list-item @click="resetDocument()"
                                            v-if="startButtonRendering && hasEditSignedPermissionRecord && utils.ActionsPermission('ResetDocument', document, transferId, delegationId, openedFromNodeId) && isActionOverflowed('btnResetDocument')">{{
                                            $t("res_Tooltip_ResetDocument") }}</v-list-item>
                                        <v-list-item @click="previewSignature" class="ReviewListItem"
                                            v-if="startButtonRendering && utils.ActionsPermission('Preview', document, transferId, delegationId , openedFromNodeId) && isActionOverflowed('Button3')">{{
                                            $t("res_CardHeaders_PreviewSignature") }}</v-list-item>
                                        <v-list-item @click="signDocument()"
                                            v-if="startButtonRendering && utils.ActionsPermission('Sign', document, transferId, delegationId , openedFromNodeId, document.canSign) && isActionOverflowed('Button4')">{{
                                            $t("res_ButtonText_Sign") }}</v-list-item>
                                        <v-list-item @click="completeTransfers(transferId)"
                                            v-if="startButtonRendering && utils.ActionsPermission('Complete', document, transferId, delegationId , openedFromNodeId) && isActionOverflowed('Button5')">{{
                                            $t("res_ButtonText_Complete") }}</v-list-item>
                                        <v-list-item @click="disableQrCode"
                                            v-if="startButtonRendering && utils.ActionsPermission('DisableQRCode', document, transferId, delegationId, openedFromNodeId) && isActionOverflowed('btnDisableQRCode')">{{
                                            $t("res_ButtonText_DisableQRCode") }}</v-list-item>
                                        <v-list-item @click="ApproveDocument"
                                            v-if="startButtonRendering && utils.ActionsPermission('Approve', document, transferId, delegationId , openedFromNodeId) && isActionOverflowed('Button7')">{{
                                            $t("res_ButtonText_Approve") }}</v-list-item>
                                        <v-list-item @click="OpenTransferForm('Sign')" class="SignTransferListItem"
                                            v-if="startButtonRendering && utils.ActionsPermission('SignAndSend', document, transferId, delegationId , openedFromNodeId, document.canSign) && isActionOverflowed('Button8')">{{
                                            $t("res_ButtonText_SignAndTransfer") }}</v-list-item>
                                        <v-list-item @click="dispatchCorrespondence(false)"
                                            v-if="startButtonRendering && utils.ActionsPermission('DispatchCorrespondence', document, transferId, delegationId , openedFromNodeId) && isActionOverflowed('Button6')">{{
                                            $t("res_ButtonText_Dispatch") }}</v-list-item>
                                        <v-list-item @click="CreateReplyLetter"
                                            v-if="startButtonRendering && utils.ActionsPermission('CreateReply', document, transferId, delegationId , openedFromNodeId) && isActionOverflowed('Button9')">{{
                                            $t("res_ButtonText_Reply") }}</v-list-item>
                                        <v-list-item @click="OpenTransferForm('Rejected')" class="RejectListItem"
                                            v-if="startButtonRendering && utils.ActionsPermission('Reject', document, transferId, delegationId , openedFromNodeId, document.canSign) && isActionOverflowed('Button10')">{{
                                            $t("res_ButtonText_Reject") }}</v-list-item>
                                        <v-list-item @click="OpenTransferForm('Forward')" class="TransferListItem"
                                            v-if="startButtonRendering && utils.ActionsPermission('Forward', document, transferId, delegationId , openedFromNodeId) && isActionOverflowed('Button11')">{{
                                            $t('res_ButtonText_Forward') }}</v-list-item>
                                        <v-list-item @click="OpenTransferForm('ForwardCc')" class="CreateCCListItem"
                                            v-if="startButtonRendering && utils.ActionsPermission('ForwardCc', document, transferId, delegationId , openedFromNodeId) && isActionOverflowed('Button12')">{{
                                            $t('res_MenuItems_ForwardCC') }}</v-list-item>
                                        <v-list-item @click="OpenTransferForm('Endorse')" class="EndorseListItem"
                                            v-if="startButtonRendering && utils.ActionsPermission('Endorse', document, transferId, delegationId , openedFromNodeId) && isActionOverflowed('Button13')">{{
                                            $t('res_ButtonText_Endorse') }}</v-list-item>
                                        <v-list-item @click="OpenTransferForm('Send Back')" class="SendBackListItem"
                                            v-if="startButtonRendering && utils.ActionsPermission('SendBack', document, transferId, delegationId , openedFromNodeId) && isActionOverflowed('Button14')">{{
                                            $t('res_ButtonText_SendBack') }}</v-list-item>
                                        <v-list-item @click="openCompleteDocumentDialog()" class="ArchiveListItem"
                                            :disabled="document.statusId!=5 && document.categoryId!= 1"
                                            v-if="utils.ActionsPermission('Archive', document, transferId, delegationId , openedFromNodeId) && !openFromManageCorrespondences && isActionOverflowed('Button15')">{{
                                            $t('res_ButtonText_Archive') }}</v-list-item>
                                        <v-list-item @click="UndoArchive(document)" class="UndoArchiveListItem"
                                            v-if="startButtonRendering && utils.ActionsPermission('UndoArchive', document, transferId, delegationId , openedFromNodeId) && isActionOverflowed('Button16')">{{
                                            $t('res_ButtonText_UndoArchive') }}</v-list-item>
                                        <v-list-item @click="dismissSent(transferId)" class="DismissSentListItem"
                                            v-if="startButtonRendering && utils.ActionsPermission('DismissSent', document, transferId, delegationId , openedFromNodeId) && isActionOverflowed('Button17')">{{
                                            $t("res_MenuItems_Dismiss") }}</v-list-item>
                                        <v-list-item @click="DismissCced(transferId)" class="DismissCcedListItem"
                                            v-if="startButtonRendering && utils.ActionsPermission('DismissCced', document, transferId, delegationId , openedFromNodeId) && isActionOverflowed('Button18')">{{
                                            $t("res_Label_CcedDismiss") }}</v-list-item>
                                        <v-list-item @click="recall()" class="RecallListItem"
                                            v-if="startButtonRendering && utils.ActionsPermission('Recall', document, transferId, delegationId , openedFromNodeId) && isActionOverflowed('Button19')">{{
                                            $t("res_MenuItems_Recall") }}</v-list-item>
                                        <v-list-item @click="notifyEmailCorrespondence(true)" class="NotifyEmailListItem"
                                            v-if="startButtonRendering && utils.ActionsPermission('NotifyEmail', document, transferId, delegationId , openedFromNodeId) && isActionOverflowed('Button20')">{{
                                            $t("res_MenuItems_NotifyEmail") }}</v-list-item>
                                        <v-list-item @click="deleteDraftDocument(document)" class="DeleteDraftListItem"
                                            v-if="startButtonRendering && utils.ActionsPermission('DeleteDraft', document, transferId, delegationId , openedFromNodeId) && isActionOverflowed('btnDeleteDraft')">{{
                                            $t("res_ButtonText_Delete") }}</v-list-item>

                                        <!-- Menu-only actions: these have no Collection 1 button, so they
                                             are always listed here. -->
                                        <v-list-item @click="openSigningHistory()"
                                            v-if="utils.ActionsPermission('SigningHistory', document, transferId, delegationId , openedFromNodeId)">{{
                                            $t("res_Label_SigningHistory") }}</v-list-item>
                                        <v-list-item @click="openDeliveryNote(document)"
                                            v-if="utils.ActionsPermission('GenerateDeliveryNote', document, transferId, delegationId , openedFromNodeId)">{{
                                            $t("res_Label_GenerateDeliveryNote") }}</v-list-item>
                                        <!-- <v-list-item @click="hideCorrespondenceDialog = true"
                                            v-if="utils.ActionsPermission('SaveForLater', document, transferId, delegationId , openedFromNodeId)">{{
                                            $t("res_Label_Hide") }}</v-list-item> -->
                                        <v-list-item @click="openVisualTracking()"
                                            v-if="openedFromNodeId != 4 && utils.ActionsPermission('VisualTracking', document, transferId, delegationId , openedFromNodeId)">{{
                                            $t("res_Label_VisualTracking") }}</v-list-item>
                                            <!--// Disable download button for now, as per the requirement of the client-->
                                        <!-- <v-list-item @click="downloadCorrespondence(false)">{{
                                            $t("res_ButtonText_Download") }}</v-list-item>
                                        <v-list-item @click="downloadCorrespondence(true)">{{
                                            $t("res_ButtonText_DownloadWithAttachments") }}</v-list-item> -->
                                        <v-list-item @click="reminderEmailDialog = true"
                                            v-if="utils.ActionsPermission('EmailReminder', document, transferId, delegationId , openedFromNodeId)">{{
                                            $t("res_ButtonText_Reminder") }}</v-list-item>
                                        <v-list-item @click="cancelFollowup()"
                                            v-if="utils.ActionsPermission('CancelFollowup', document, transferId, delegationId , openedFromNodeId)">{{
                                            $t("res_ButtonText_CancelFollow_Up") }}</v-list-item>
                                        <v-list-item @click="cancelCorrespondence(document)"
                                            v-if="utils.ActionsPermission('CancelDocument', document, transferId, delegationId , openedFromNodeId)">{{
                                            $t("res_ButtonText_Cancel") }}</v-list-item>
                                        <v-list-item v-if="utils.ActionsPermission('EmailDispatchCorrespondence', document, transferId, delegationId , openedFromNodeId)"
                                            @click="sendCorrespondence(true)"> {{
                                            $t("res_Label_EmailDispatch") }}</v-list-item>
                                    </v-list>
                                </v-menu>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <v-dialog v-model="showGenerateAdvance" width="600" persistent>
                <v-card>
                    <v-card-title>
                        {{ $t('res_Tooltip_GenerateReferenceNumber')}}
                    </v-card-title>
                    <div :style="style_generateReferenceNumber">
                        <div class=" inner-single-component">
                            <div>
                                <div class="d-flex justify-content-between align-items-center">
                                    <div class="margin-right-auto">
                                        <h3 class="main-text-large">{{ $t("res_Label_Signees") }}</h3>
                                    </div>
                                    <v-btn class="dgs-new-button ml-2 mr-2"
                                        v-if="documentSignersCount > 0 && this.signers_GenerateReferenceNumberAdvance.length < documentSignersCount"
                                        @click="addNewSignee_GenerateReferenceNumberAdvance">{{$t('Add')}}</v-btn>
                                </div>
                                <v-divider v-if="this.signers_GenerateReferenceNumberAdvance.length > 0"></v-divider>
                                <Container drag-handle-selector=".column-drag-handle" drag-class="opacity-ghost"
                                    @drop="signeesOnDrop($event,true)"
                                    :style="{ display: collapseSigners ? 'block':'block' }">
                                    <Draggable class="col-md-12 p-0"
                                        v-for="(item, index) in this.signers_GenerateReferenceNumberAdvance"
                                        :key="index" drag-handle-selector=".column-drag-handle">
                                        <label class="label_required" style="cursor:pointer">{{ $t("res_Label_Signee")
                                            }} {{ index + 1 }} *</label>
                                        <div class="d-flex align-items-center column-drag-handle">
                                            <v-icon style="bottom: 10px;cursor:pointer;">mdi-dots-vertical</v-icon>
                                            <div class="with-absolute-button flex-1" style="padding-bottom: 20px;">
                                                <StructureUserSelector :showInternalUsers="true"
                                                    :showExternalUsers="false" :showInternalStructures="false"
                                                    :showExternalStructures="false" :excludeSelf="false"
                                                    :isMultiple="false" :isForSignee="true"
                                                    :selectedStructureUser="item.index && !item.id ? undefined : item"
                                                    :dataToPassOnSelectChange="index"
                                                    @structureUserSelectChanged="GenerateAdvance_documentSigneeSelectedChange"
                                                    :addressBook_header="$t('res_Label_SelectSignee')">
                                                </StructureUserSelector>
                                            </div>
                                            <v-icon style="bottom: 10px; cursor: pointer;"
                                                @click="deleteSignee_GenerateReferenceNumberAdvance(index)">mdi-delete</v-icon>
                                        </div>
                                    </Draggable>
                                </Container>
                            </div>
                        </div>
                    </div>
                    <div class="mb-2">

                        <v-btn class="primary ml-2 mr-2" style="cursor:pointer !important"
                            v-if="signers_GenerateReferenceNumberAdvance.length > 0" @click="forceGenerateAdvance">
                            {{$t('res_ButtonText_Generate')}}
                            <v-progress-circular v-show="forceGenerateAdvance_UploadLoader" color="white"
                                class="mt-2 ml-1 mb-1" indeterminate :size="15"></v-progress-circular>
                        </v-btn>

                        <v-btn class="ml-2 mr-2 light-blue" style="cursor:pointer !important"
                            @click="closeGenerateAdvanceDialog">
                            {{$t('res_ButtonText_Cancel')}}
                        </v-btn>
                    </div>
                </v-card>
            </v-dialog>


            <v-dialog v-model="openScanDialog" content-class="dialog fullscreen-dialog bg-white" fullscreen>
                <v-card>
                    <v-toolbar class="bg-white">
                        <v-card-title class="p-0">{{ $t('ResourceScanFile') }}</v-card-title>
                        <v-spacer></v-spacer>
                        <v-btn class="close-btn light-btn" icon dark @click="openScanDialog = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <ScanFile :documentId="documentId" @GetImageData="uploadScan"></ScanFile>
                </v-card>
            </v-dialog>

            <v-dialog persistent v-model="previewSignatureDialog"
                content-class="preview-signature-dialog fullscreen-dialog dialog with-fixed-actions bg-white"
                width="100%" fullscreen>
                <div class="dialog-header">
                    <v-toolbar class="bg-white">
                        <div class="custom-icon-wrapper">
                            <v-icon @click="previewSignatureDialog=false">custom-icon left-arrow-icon</v-icon>
                        </div>
                        <h1 class="mb-0">
                            {{ $t("res_CardHeaders_PreviewSignature") }}
                        </h1>
                        <v-spacer></v-spacer>
                        <div class="custom-icon-wrapper">
                            <v-icon @click="previewSignatureDialog=false">custom-icon mdi-close</v-icon>
                        </div>
                    </v-toolbar>
                </div>
                <div class="dialog-body">
                    <preview-signature :documentId="documentId" @closeDialog="closeReviewSignatureDialog"/>
                </div>
            </v-dialog>

            <v-dialog v-model="notifyEmailDialogCorrespondence"
                content-class="choose-template-dialog fullscreen-dialog dialog with-fixed-actions bg-white w-40 right"
                fullscreen width="70%" scrollable>
                <v-card>
                    <v-toolbar class="bg-white">
                        <v-card-title class="p-0">
                            {{ $t("res_MenuItems_SendBy") }}
                        </v-card-title>
                        <v-spacer></v-spacer>
                        <div class="custom-icon-wrapper">
                            <v-icon @click="notifyEmailDialogCorrespondence=false">custom-icon mdi-close</v-icon>
                        </div>
                    </v-toolbar>
                    <notify-email id="notifyEmailCorrespondence"
                        v-on:closeDialog="closeNotifyEmail = false" :isSent="nodeId == 6 ? true : false"
                        :subject="notifySubject" :documentId="documentId" :transferId="transferId" :toUserId="toUserId"
                        :dialogModelShow="notifyEmailDialogCorrespondence">
                    </notify-email>
                </v-card>
            </v-dialog>

            <v-dialog v-model="reminderEmailDialog" content-class="small-dialog" width="400px">
                <v-card>
                    <v-card-title class="p-0">
                        {{ $t("res_ButtonText_Reminder") }}
                    </v-card-title>
                    <div class="card-body">
                        <div class="col-sm-12">
                            <label class="label_required">{{ $t("res_Label_ToDate") }} *</label>
                            <v-menu content-class="p-0" v-model="remindToDateMenu" :close-on-content-click="false"
                                :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field v-model="reminderToDate" :label="$t('res_Label_SelectDate')" readonly v-bind="attrs" v-on="on"
                                        solo append-icon="mdi-calendar" :tabindex="-1">
                                        <template v-slot:append>
                                            <v-icon v-bind="attrs" v-on="on">mdi-calendar</v-icon>
                                        </template>
                                    </v-text-field>
                                </template>
                                <v-date-picker :locale="selectedLang" v-model="reminderToDate"
                                    @input="remindToDateMenu = false" :min="nowDate"></v-date-picker>
                            </v-menu>
                        </div>
                    </div>
                    <v-card-actions class="gap-2 sticky-actions">
                        <v-spacer></v-spacer>
                        <v-btn color="primary" @click="reminderEmailDialog = false">{{ $t("res_ButtonText_Cancel")
                            }}</v-btn>
                        <v-btn color="primary" @click="ReminderByEmail()">{{ $t("res_ButtonText_Continue") }}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-overlay :value="transferFormDialog">
                <v-dialog v-model="transferFormDialog" content-class="dialog with-fixed-actions bg-white w-40 right"
                    fullscreen width="70%" scrollable>
                    <v-card>
                        <v-toolbar class="bg-white">
                            <v-card-title class="p-0">
                                {{ transferFormHeader }}
                            </v-card-title>
                            <v-spacer></v-spacer>
                            <div class="custom-icon-wrapper">
                                <v-icon @click="transferFormDialog=false">custom-icon mdi-close</v-icon>
                            </div>
                        </v-toolbar>

                        <TransferForm :canSignWithoutPinCode="canSignWithoutPinCode" :documentId="documentId"  
                            :isDelegatedDocumentTransferProp="this.isDelegatedDocument()"
                            :disableRecipient="recipientDisabled" :disableAdvancedTransfer="disableAdvancedTransfer"
                            :purpose="purpose" :transferId="transferId" :transferCC="transferCC" :sign="signForm"
                            :propertyBag="propertyBag" :transferFormDialog="transferFormDialog"
                            :delegationId="delegationId" :rejected="rejected" :successMessage="transferSuccessMessage"
                            :transferTo="transferTo" :categoryId="document.categoryId"
                            :transferToMulti="transferToMulti" :transferFormType="transferFormType"
                            :clientVersionId="constants.client_version_Id"
                            :checkForAttachmentsUploadMultiApproval="checkForAttachmentsUploadMultiApproval"
                            :statusId="document.statusId" :defaultDueDate="document.dueDate"
                            @closeTransformDialog="closeTransferFormDialog"
                            @cancelCorrespondenceDocument="transferFormDialog = false"
                            :noteIsMandatory="false" :forwardCC="forwardCc"
                            :enableRecipientsMultiPages="multiDocument" />
                    </v-card>
                </v-dialog>
            </v-overlay>

            <v-dialog v-model="signFormDialog" :persistent="true" content-class="small-dialog" width="650" height="750">
                <v-card>
                    <v-card-title>
                        {{ $t("res_CardHeaders_Sign") }}
                    </v-card-title>
                    <div style="overflow: hidden">
                        <Sign :canSignWithoutPinCode="canSignWithoutPinCode" :propertyBag="propertyBag"
                            :dialogModelShow="signFormDialog"
                            @refreshAfterClosingSignDialog="refreshAfterClosingSignDialog"
                            :isSignAndSend="false"
                            :enableRecipientsMultiPages="multiDocument"
                            @closeSignFormDialog="closeSignFormDialog" :isDelegatedDocumentSignProp="this.isDelegatedDocument()"/>
                    </div>
                </v-card>
            </v-dialog>

            <v-dialog v-model="selectSignMethodFormDialog" :persistent="true" content-class="small-dialog" width="650"
                height="750">
                <v-card>
                    <v-card-title class="text-h5 blue lighten-2">
                        {{ $t("res_CardHeaders_Sign") }}
                    </v-card-title>
                    <div style="overflow: hidden">
                        <SignSelectSignMethod :propertyBag="propertyBag" :dialogModelShow="signFormDialog"
                            :allowUAEPASSSignature="allowUAEPASSSignature" :allowESignature="allowESignature"
                            @closeSignMethodSelectAndOpenSignWithPin="closeSignMethodSelectAndOpenSignWithPin"
                            @closeSelectSignMethodFormDialog="closeSelectSignMethodFormDialog"
                            @closeSignFormDialog="closeSignFormDialog" :isSignAndSend="false"
                            :isUAEPassEnabledForTemplate="selectedTemplate?selectedTemplate.isUAEPassEnabled:false"
                            :isEsealEnabledForTemplate="selectedTemplate?selectedTemplate.isEsealEnabled:false"
                            @refreshAfterClosingSignMethodSelect="refreshAfterClosingSignMethodSelect" />
                    </div>
                </v-card>
            </v-dialog>

            <v-dialog v-model="signingHistoryDialog"
                content-class="dialog with-fixed-actions bg-white  justify-content-center w-50" fullscreen scrollable>
                <v-card class="bg-white">
                    <v-toolbar class="bg-white">
                        <v-card-title>
                            {{ $t("res_CardHeaders_SigningHistory") }}
                        </v-card-title>
                        <v-spacer></v-spacer>
                        <div class="custom-icon-wrapper">
                            <v-icon @click="signingHistoryDialog = false">custom-icon mdi-close</v-icon>
                        </div>
                    </v-toolbar>
                    <v-card-text class="border-top p-0 d-flex">
                        <SigningHistory :documentId="documentId" :dialogModelShow="signingHistoryDialog">
                        </SigningHistory>
                    </v-card-text>

                    <!-- signing history button -->
                    <v-card-actions class="d-flex justify-content-end" style="background-color:  #E7EBEF;">
                        <v-btn class="dgs-new-button-inner" style="height: 48px" @click="openVisualTracking()"
                            v-if="this.document.showVisualTracking">
                            <img class="rtl-flip" src="/assets/images/icons/tracking.svg" />{{ $t('res_ButtonText_VisualTracking') }}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <div v-if="signingHistoryDialog" class="overlay"></div>

            <v-dialog v-model="visualTrackingDialog"
                content-class="tracker-container dialog with-sticky-actions bg-white" width="100%" fullscreen>
                <div class="dialog-header">
                    <div class="custom-icon-wrapper tracker-close">
                        <v-icon @click="visualTrackingDialog = false">custom-icon mdi-close</v-icon>
                    </div>
                </div>
                <div class="dialog-body h-100">
                    <iframe id="trackingFrame" :src="trackingFrameSrc"
                        style="width: 100%; height: 100%; min-height: 1000px;"></iframe>
                </div>
            </v-dialog>

            <v-dialog persistent v-model="linkedDocumentDialog"
                content-class="linked-document-dialog fullscreen-dialog dialog with-fixed-actions bg-white" width="100%"
                fullscreen>
                <div class="dialog-header">
                    <v-toolbar class="bg-white">
                        <div class="custom-icon-wrapper">
                            <v-icon @click="closeLinkedDocumentPopup()">custom-icon left-arrow-icon</v-icon>
                        </div>
                        <h1 class="mb-0">{{ $t("res_CardHeaders_SelectLinkedMail") }}</h1>
                        <v-spacer></v-spacer>
                        <div class="custom-icon-wrapper">
                            <v-icon @click="closeSelectLinkedDocumentPopup">custom-icon mdi-close</v-icon>
                        </div>
                    </v-toolbar>
                </div>
                <div class="dialog-body">
                    <LinkedDocument ref="linkedDocument" :documentId="documentId"
                        @closeSelectLinkedDocumentPopup="closeSelectLinkedDocumentPopup"
                        :dialogModelShow="linkedDocumentDialog"></LinkedDocument>
                </div>
            </v-dialog>

            <v-dialog v-model="correspondenceDialog"
                content-class="create-document-dialog fullscreen-dialog corr_dialog" fullscreen :persistent="true"
                @keydown.esc="closeCorrespondenceDialog">
                <CreateDocumentView :documentId="linkedDocumentId" :transferId="linkedTransferId"
                    :dialogCount="dialogCount" viewMode="readonly" :delegationId="linkedDelegationId"
                    :closeDialogEvent="closeCorrespondenceDialog" :viewingLinkedDocument="true" />
            </v-dialog>

            <v-dialog v-model="LinkedEmailDeleteDialog" content-class="small-dialog" width="600" height="250">
                <v-card>
                    <v-card-title>
                        {{ $t("res_DialogTitle_DeleteLinkedEmail") }}
                    </v-card-title>
                    <div class="card-body">
                        <label class="mt-2">
                            {{ $t("res_Msgs_DeleteLinkedEmailConfirmation") }}
                        </label>
                    </div>
                    <v-card-actions class="gap-2 sticky-actions">
                        <v-spacer></v-spacer>
                        <v-btn class="light-blue" @click="cancelLinkedEmailDeleteDialog">{{ $t("res_ButtonText_Cancel")
                            }}</v-btn>
                        <v-btn class="primary" @click="deleteLinkedDocument">{{ $t("res_ButtonText_Delete") }}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-dialog v-model="completeDocumentDialog" content-class="small-dialog" width="500" height="350">
                <v-card>
                    <v-card-title>
                        {{ $t("res_DialogTitle_CompleteNotes") }}
                    </v-card-title>
                    <div class="card-body">
                        <label>{{ $t("res_Msgs_EnterNotes") }} *</label>
                        <v-textarea v-model="completeDocument_noteText" solo></v-textarea>
                        <br>
                        <!--  <v-btn v-if="this.archiveToDMSCabinet" color="primary" @click="openDmsCabinetSelector">{{ $t("res_ButtonText_SelectCabinet") }}</v-btn> -->
                        <template v-if="this.archiveToDMSCabinet">
                            <div class="mt-2">
                                <label>{{ $t("res_label_DMSCabinets")}} *</label>
                                <DmsCabinetSelector @DmsCabinetSelectChanged="dmsCabinetSelectChanged">
                                </DmsCabinetSelector>
                            </div>
                        </template>
                        <template v-if="showClassificationField == true">
                            <div class="mt-2">
                                <label>{{ $t("res_label_ClassificationPlan")}} *</label>
                                <FilingClassificationPlanSelector :mode="2" :selectedClassificationPlan="null"
                                    @ClassificationPlanSelectChanged="classificationPlanSelectChanged">
                                </FilingClassificationPlanSelector>
                            </div>
                        </template>
                    </div>
                    <v-card-actions class="gap-2 sticky-actions">
                        <v-spacer></v-spacer>
                        <v-btn class="dgs-new-button"
                            @click="completeDocument_noteText = ''; completeDocumentDialog = false;">{{
                            $t("res_ButtonText_Cancel") }}</v-btn>
                        <v-btn color="primary" @click="completeDocument">{{ $t("res_ButtonText_Continue") }}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-dialog v-model="addFavoriteDialog" content-class="profile-dialog system-notifiction m-0" width="400px">
                <v-card class="p-2 card-scroll">
                    <v-card-text>
                        <v-text-field class="bg-gray p-2" style="border-radius: 10px;" label="" v-model="favoriteName"
                            :placeholder="$t('res_Label_Name')">
                        </v-text-field>
                    </v-card-text>
                    <v-card-actions class="d-flex">
                        <v-btn class="flex-1" color="primary" @click="addFavoriteDialog = false">{{
                            $t("res_ButtonText_Cancel") }}</v-btn>
                        <v-btn class="flex-1" color="primary" @click="addFavoriteDocument">{{
                            $t("res_Label_AddToFavorite") }}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-dialog v-model="removeFavoriteDialog" content-class="small-dialog" width="500" height="350">
                <v-card>
                    <v-card-title>
                        {{ $t("res_Label_Alert") }}
                    </v-card-title>
                    <div class="card-body">
                        <h3>{{ $t("res_Msgs_EnsureRemoveFavorite") }}</h3>

                    </div>
                    <v-card-actions class="gap-2 sticky-actions">
                        <v-spacer></v-spacer>
                        <v-btn color="primary" @click="removeFavoriteDialog = false">{{ $t("res_ButtonText_Cancel")
                            }}</v-btn>
                        <v-btn color="primary" @click="removeFavorite">{{ $t("res_ButtonText_Continue") }}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-dialog :v-model="dispatchCorrespondenceFormDialog1" width="500" height="400">
                <v-card>
                    <v-toolbar class="bg-white">
                        <v-card-title class="p-0">
                            {{ $t("res_DialogTitle_DispatchCorrespondence") }}
                        </v-card-title>
                        <v-spacer></v-spacer>
                        <v-btn class="close-btn light-btn" icon dark @click="dispatchCorrespondenceFormDialog1=false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <DispatchCorrespondence :documentId="documentId"
                        :dialogModelShow="dispatchCorrespondenceFormDialog1" :nodeId="openedFromNodeId"
                        v-on:closeDialog="dispatchCorrespondenceFormDialog1 = false"></DispatchCorrespondence>
                </v-card>
            </v-dialog>

            <v-dialog v-model="dispatchCorrespondenceFormDialog" content-class="small-dialog" width="500" height="350">
                <v-card>
                    <v-card-title>
                        <span>{{ $t("res_DialogTitle_DispatchCorrespondence") }}</span>
                    </v-card-title>
                    <div class="card-body">
                        <label>{{ $t("res_Msgs_EnsureDispatchCorrespondence") }}</label>
                    </div>
                    <v-card-actions class="gap-2 sticky-actions">
                        <v-btn color="primary" @click="dispatchCorrespondenceFormDialog=false">{{
                            $t("res_ButtonText_Cancel") }}</v-btn>
                        <v-btn color="primary" @click="DispatchCorrespondenceToEntities()">{{
                            $t("res_ButtonText_Continue") }}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <DispatchResultDialog v-model="dispatchResultDialog" :dispatchedEntities="dispatchedEntities"
                :viaEmailEntities="viaEmailEntities" :failedEntities="failedEntities"
                :warningMessage="dispatchResultWarning" v-on:closed="onDispatchResultClosed()" />

            <v-overlay :value="emailDispatchDocumentDialog">
                <v-dialog v-model="emailDispatchDocumentDialog" content-class="dialog with-fixed-actions bg-white w-40 right"
                    fullscreen width="70%" scrollable>
                    <v-card>
                        <v-toolbar class="bg-white">
                            <v-card-title class="p-0">
                                {{ $t("res_Label_EmailDispatch") }}
                            </v-card-title>
                            <v-spacer></v-spacer>
                            <v-btn class="close-btn light-btn" icon dark @click="emailDispatchDocumentDialog = false">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </v-toolbar>
                        <EmailDispatchDocumentForm :documentSubject="subject" :documentId="documentId" v-if="emailDispatchDocumentDialog" :nodeId="openedFromNodeId"
                            :dialogModelShow="emailDispatchDocumentDialog" :withAttachments="true"
                            v-on:closeDialog="emailDispatchDocumentDialog = false"></EmailDispatchDocumentForm>
                    </v-card>
                </v-dialog>
            </v-overlay>

            <v-dialog v-model="dispatchCorrespondenceByEmailDialog"
                content-class="dialog with-fixed-actions bg-white w-40 right" fullscreen width="70%" scrollable>
                <v-card>
                    <v-toolbar class="bg-white">
                        <v-card-title class="p-0">
                            {{ $t("res_Label_EmailDispatch") }}
                        </v-card-title>
                        <v-spacer></v-spacer>
                        <v-btn class="close-btn light-btn" icon dark @click="dispatchCorrespondenceByEmailDialog=false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <EmailDispatchDocumentForm :documentSubject="subject" :documentId="documentId" v-if="emailDispatchDocumentDialog" :nodeId="openedFromNodeId"
                        :dialogModelShow="emailDispatchDocumentDialog" :withAttachments="true"
                        v-on:closeDialog="emailDispatchDocumentDialog = false"></EmailDispatchDocumentForm>
                </v-card>
            </v-dialog>

            <v-dialog v-model="deliveryNoteDialog" content-class="small-dialog" width="650" height="1350">
                <v-card>
                    <v-card-title>{{ $t('res_Label_DeliveryNote') }}</v-card-title>
                    <div style="overflow: hidden">
                        <DeliveryNoteConfiguration :documentId="documentId" :referenceNumber="referenceNumber"
                            :deliveryNoteDialog="deliveryNoteDialog" @closeDeliveryNote="deliveryNoteDialog = false" />
                    </div>
                </v-card>
            </v-dialog>

            <v-dialog v-model="hideCorrespondenceDialog" content-class="small-dialog" width="400px">
                <v-card>
                    <v-card-title>
                        {{ $t("res_Label_Hide") }}
                    </v-card-title>
                    <div class="card-body">
                        <div class="col-sm-12">
                            <label class="label_required">{{ $t("res_Label_ToDate") }} *</label>
                            <v-menu content-class="p-0" v-model="hideToDateMenu" :close-on-content-click="false"
                                :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field v-model="hideToDate" :label="$t('res_Label_SelectDate')" readonly v-bind="attrs" v-on="on" solo
                                        append-icon="mdi-calendar" :tabindex="-1">
                                        <template v-slot:append>
                                            <v-icon v-bind="attrs" v-on="on">mdi-calendar</v-icon>
                                        </template>
                                    </v-text-field>
                                </template>
                                <v-date-picker :locale="selectedLang" v-model="hideToDate"
                                    @input="hideToDateMenu = false" :min="nextDate"></v-date-picker>
                            </v-menu>
                        </div>
                    </div>
                    <v-card-actions class="gap-2 sticky-actions">
                        <v-spacer></v-spacer>
                        <v-btn color="primary" @click="hideCorrespondenceDialog = false">{{ $t("res_ButtonText_Cancel")
                            }}</v-btn>
                        <v-btn color="primary" @click="SaveForLater">{{ $t("res_ButtonText_Continue") }}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-dialog fullscreen content-class="fullscreen-dialog" v-model="visualTrackingDialogNew">
                <TrackingView2 :documentId="visualTrackingDialogNew_selectedDocumentId"
                    :closeDialogFunc="closeNewTrackerDialog" />
            </v-dialog>

        </div>
    </v-card>
</template>

<script>
    import axios from 'axios';
    import constants from '@/assets/js/constants.js'
    import { getTransferPurposes } from '@/store/modules/lookups.js'
    import MultiSelect from 'vue-multiselect'
    import * as utils from '@/assets/js/common.js'
    import Attachments from '@/components/Attachments.vue'
    import Notes from '@/components/Notes.vue'
    import TransferList from '@/components/TransferList.vue'
    import PreviewSignature from '@/components/PreviewSignature.vue'
    import TransferForm from '@/components/TransferForm.vue'
    import VueWysiwyg from '@mycure/vue-wysiwyg'
    import SigningHistory from '@/components/SigningHistory.vue'
    import DocumentDispatchLetter from '@/components/DocumentDispatchLetter.vue'
    import TrackingTree from '@/components/TrackingTree.vue'
    import Sign from '@/components/Sign.vue'
    import LinkedDocument from '@/components/LinkedDocuments.vue'
    import CreateDocumentView from '@/views/CreateDocumentView.vue'
    import UserInfo from '@/components/UserInfo.vue'
    import NotifyEmail from '@/components/NotifyEmail.vue'
    import debounce from "lodash.debounce"
    import StructureUserSelector from '@/components/StructureUserSelector.vue'
    import { Container, Draggable } from 'vue-smooth-dnd'
    import TransferNotesIcon from '@/components/TransferNotesIcon.vue'
    import SignSelectSignMethod from '@/components/SelectSignMethod.vue'
    import RecipientSenderSelector from '@/components/RecipientSenderSelector.vue'
    import DocumentSelector from '@/components/DocumentSelector.vue'
    import DispatchCorrespondence from '@/components/DispatchCorrespondence.vue'
    import EmailDispatchDocumentForm from '@/components/EmailDispatchDocumentForm.vue'
    import DispatchInfo from '@/components/DispatchInfo.vue'
    import DispatchResultDialog from '@/components/DispatchResultDialog.vue'
    import DeliveryNoteConfiguration from '@/components/DeliveryNoteConfiguration.vue'
    import FilingClassificationPlanSelector from '@/components/FilingClassificationPlanSelector.vue'

    import TrackingView2 from "@/views/TrackingView2.vue";
    import ScanFile from '@/components/ScanFile.vue';

    import DmsCabinetSelector from '@/components/DmsCabinetSelector.vue';

    export default {
        name: 'CreateDocumentView',
        components: {
            TrackingView2,DocumentDispatchLetter,
            MultiSelect, Container, Draggable, Attachments, Notes, TransferList, PreviewSignature, VueWysiwyg,
            TransferForm, SigningHistory, TrackingTree, Sign, LinkedDocument, NotifyEmail, CreateDocumentView, UserInfo,
            StructureUserSelector, TransferNotesIcon, SignSelectSignMethod, RecipientSenderSelector, DocumentSelector, DispatchCorrespondence,
            EmailDispatchDocumentForm, DispatchInfo,DispatchResultDialog, FilingClassificationPlanSelector, DeliveryNoteConfiguration, ScanFile
            , DmsCabinetSelector
        },
        props: {
            dialogOpenClose: { type: Boolean },
            documentId: { type: [String, Number], default: '0' },
            dialogCount: { type: Number, default: 1 },
            transferId: { type: [String, Number], default: '0' },
            delegationId: { type: Number, default: 0 },
            viewMode: { type: String, default: 'readonly' },
            openedFromNodeId: { type: Number, default: 0 },
            openerPage: { type: String, default: '' },
            closeDialogEvent: { type: Function, default: function () { } },
            createReplyDocumentEvent: { type: Function, default: function() { } },
            linkedFromDocumentId: { type: Number, default: 0 },
            toEmail: '',
            emailCC: '',
            viewingLinkedDocument: { type: Boolean, default: false },
            openFromManageCorrespondences: { type: Boolean, default: false },
            isOpenedFromAdvancedSearch: { type: Boolean, default: false },
        },
        data() {
            return {
                CommentsLabel: "",
                downloadWithoutHeaderAndFooterAndWithSignature: false,
                printWithoutHeaderAndFooterAndWithSignature: false,
                clearRecipientSenderSelectorInputs: false,
                showConfigureSignatures: false,
                enableSignWithOutPinCodeFeature: false,
                canSignWithoutPinCode: false,
                areTagsEnabled: false,
                qrCodeEnabled: false,
                hasEditSignedPermissionRecord: false,
                PrintOptions: false,
                showClassificationField: constants.showClassificationField,
                showTemplateInfoCard: false, 
                templateInfo:  { 
                    Id: 0,
                    Name: '',
                    Description: '',
                    Language: '',
                    SignatureCount: 0, 
                },   
                forwardCc:false,
                multiDocument: '0',
                PrintingOptionsMultiplelbl: this.$t('res_Label_PrintingOptionsMultiple'),
                PrintingOptionsSinglelbl: this.$t('res_Label_PrintingOptionsSingle'),
                emailLabel: '',
                viewOutgoingAddedFields: false,
                viewInternalAddedFields: false,
                viewIncomingAddedFields: false,
                viewPrintingOptions:  window.viewPrintingOptions,  
                classificationPlanIdRequired: true,
                selectedLang: 'en', 
                formattedReceivedDate: '',
                messageType_items: [],
                document_receivedDate_menu: false,
                visualTrackingDialogNew: false,
                visualTrackingDialogNew_selectedDocumentId: 0,
                rejected: false,
                sentBack: false,
                transferSuccessMessage: '',
                recipientDisabled: false,
	            transferFormType: '',
                formattedDate: '',
                formattedDueDate: '',
                notifySubject: '',
                DownloadOptions:false,
                isLanguageEn: true,
                notifyEmailDialogCorrespondence: false,
                LinkedEmailDeleteDialog: false,
                loading: false,
                correspondenceDialog: false,
                count: 0,
                counter: 0,
                documentSignersCount: 0,
                nowDate: new Date().toISOString().slice(0, 10),
                user_structures: [],
                user_structure: {},
                cc_items: [],
                priority_items: [],
                privacy_items: [],
                importance_items: [],
                document_date_menu: false,
                document_due_date_menu: false,
                TranslatedSubjectLabel: '',
                KeywordsLabel: '',
                OtherAttachmentsLabel: '',
                reminderEmailDialog: false,
                hideToDateMenu: false,
                reminderToDate: '',
                fromEmail: [],
                remindToDateMenu: false,
                emailDispatchDocumentDialog: false,
                withAttachments: false,
                selectedDocumentId: 0,
				documentType_items: [],					   
                document: {
                    categoryId: 0,
                    cc: [],
                    requestingDepatment: null,
                    amount: '',
                    send_after_sign: [],
                    priority: {},
                    privacy: {},
                    importance: {},
                    externalReferenceNumber: '',
                    date: '',
                    subject: '',
                    dueDate: '',
                    translatedSubject: '',
                    keywords: '',
                    otherAttachments: '',
                    signers: [],
                    formData: {},
                    purposeId: 0,
                    secretForward: false,
                    purposeIdBeforeRevoke: 0,
                    // for AdPorts
                    hrmsEmployee: '',
                    // for NLA
                    project: '',
                    projectNumber: '',
                    isNeedReply: null,
                    replyDocument: {},
                    tags: [],
                    //for Incoming Document
                    receivedDate:'',
                    messageType: 0, 
					documentType: {},
                    documentTypeId: null,
                    openedByCreator: false
                },
                subject: '',
                signersList: [],

                signerSelectionEnabled: true,
                selectedTemplate: null,
                canSignDocument : true,
                showCCBlock: false,
                showTranslatedSubjectBlock: false,
                showCommentsBlock: false,
                showOtherAttachmentsBlock: false,

                barcodeFormDialog: false,
                barcodeImage: '',

                empty_viewer: true,
                viewerFrameSrc: '',

                canSignDocument: false,
                previewSignatureDialog: false,
                documentSignersBackup: '',
                signers_GenerateReferenceNumberAdvance: [],

                transfer: {},
                documentInfo: {},

                transferCC: [],
                transferTo: {},
                transferToMulti: [],
                transferFormHeader: window.translate("res_Label_Transfer"),
                transferFormDialog: false,
                signFormDialog: false,
                propertyBag: {},
                purpose: {},
                purposeId: 0,
                signForm: false,
                checkForAttachmentsUploadMultiApproval: false,
                disableAdvancedTransfer:true,
                isSecretNote:false,
                toUserId: 0,
                fromUserId: 0,
                loginUserId:0,

                trackingFrameSrc: '',
                signingHistoryDialog: false,
                visualTrackingDialog: false,
                linkedDocumentDialog: false,
                linkedDocuments: [],
                linkedDocumentsFullList: [],
                defaultNumberOfLinkedDocumentsToDisplay: 3,
                numberOfLinkedDocumentsToDisplay: 3,

                linkedDocumentId: '',
                linkedTransferId: '',
                linkedDelegationId: '',
                linkedDocumentToDeleteId: 0,

                completeDocumentDialog: false,
                completeDocument_noteText: '',
                isImportanceFieldVisible: true,
                hideMessageType: false,
                utils: utils,
                debouncedHandlerSigner: null,
                constants: constants,
                selectSignMethodFormDialog: false,
                dispatchCorrespondenceFormDialog: false,
                dispatchCorrespondenceFormDialog1: false,
                dispatchCorrespondenceByEmailDialog: false,
                dispatchResultDialog: false,
                dispatchResultWarning: '',
                dispatchedEntities: [],
                viaEmailEntities: [],
                failedEntities: [],

                //FavoriteDocument
                addFavoriteDialog: false,
                removeFavoriteDialog: false,
                favoriteName:'',
                isFavorite: false,
                showReplyDocumentSection: false,
                nodeId: 0,
                tagOptions:[],
                deliveryNoteDialog: false,
                referenceNumber: "",
                hideCorrespondenceDialog: false,
                hideToDate: '',
                hideToDateMenu: false,
                filingClassificationPlanMode: {
                    FilingPlanMode: 1,
                    ClassificationPlanMode: 2,
                    BothPlanModes: 3
                },
                attachmentId: 0,
                showRegisterFrom: window.showRegisterFrom,
                showNormalForceGenerateRF: true,
                showAdvanceForceGenerateRF: window.showAdvanceForceGenerateRF,
                showGenerateAdvance: false,
                forceGenerateAdvance_UploadLoader: false,

                collapseDetails : false,
                collapseTransferDetails: false,
                collapseDocumentDetails: false,
                collapseLinkedDocuments : false,
                collapseAttachments : false,
                collapseSigners : true,
                openScanDialog : false,
                isMenuOpen: false,
                PrintOption: false,
                style_generateReferenceNumber: {
                    maxHeight: '1000px',
                    overflowY: 'auto'
                },
                statusId : 0,
                classificationPlanId: 0,
                overflowedActionKeys: [],
                startButtonRendering: false,
                selectedAttachmentExtension: '',
                archiveToDMSCabinet: ArchiveToDMSCabinet,
                dmsSelectedCabinetId: null,
                userId: JSON.parse(sessionStorage.getItem("user")).profile.Id,
                multipleTransferNotesExist: false,
                allowESignature: false,
                allowUAEPASSSignature: false
            }
        }, 
        async mounted()
        {
            // .rowContainer is full width, so it changes size with the window
            this.onFooterResize = () =>
            {
                clearTimeout(this.footerResizeTimer);
                this.footerResizeTimer = setTimeout(this.measureFooterButtons, 100);
            };
            window.addEventListener('resize', this.onFooterResize);

            this.showTranslatedSubjectBlock = window.showTranslatedSubjectBlock
            this.showCommentsBlock = window.shouldShowCommentsBlock
            this.showOtherAttachmentsBlock = window.shouldShowOtherAttachmentsBlock
            this.downloadWithoutHeaderAndFooterAndWithSignature = window.downloadWithoutHeaderAndFooterAndWithSignature;
            this.printWithoutHeaderAndFooterAndWithSignature= window.printWithoutHeaderAndFooterAndWithSignature
            this.enableSignWithOutPinCodeFeature = window.enableSignWithOutPinCodeFeature
            this.areTagsEnabled = window.areTagsEnabled
            this.canSignWithoutPinCode = await this.fetchCanSignWithoutPin()
            this.selectedLang =  localStorage.getItem('lang');
            if (document.querySelectorAll('.v-application--is-rtl').length) 
                this.isLanguageEn = false

            this.TranslatedSubjectLabel = window.translate("res_Label_TranslatedSubject")
            this.CommentsLabel = window.translate("res_Label_Keywords")
            this.OtherAttachmentsLabel = window.translate("res_Label_OtherAttachments")
            this.viewerFrameSrc = ''
            this.empty_viewer = true
            await this.getUserStructures()
            this.getLookupItems()
            this.getDocumentWithTransfer();
            this.getLinkedDocuments();
            this.checkFavorite();

            this.isImportanceFieldVisible = window.isImportanceFieldVisible;
            this.hideMessageType = window.hideMessageType;
            var user = JSON.parse(sessionStorage.getItem("user"));
            this.fromEmail = user.profile.Email
            this.loginUserId = user.profile.Id

            if(this.priority_items && this.priority_items.length>0){
                this.document.priority = this.priority_items[0]
                this.priorityChanged(this.document.priority)
            }

            this.openDefaultSignerMethod();
        },
        beforeDestroy()
        {
            window.removeEventListener('resize', this.onFooterResize);
            clearTimeout(this.footerResizeTimer);
        },
        watch:
        {
            async documentId() 
            {    
                this.favoriteName = ''
                this.viewerFrameSrc = ''
                this.getLinkedDocuments()
                await this.getUserStructures()
                this.checkFavorite();
                if (this.documentId > 0 && this.transferId == 0) 
                {
                        this.getDocumentWithTransfer(); 
                        this.clearRecipientSenderSelectorInputs = false; 
                }
                else 
                { 
                    this.clearRecipientSenderSelectorInputs = true; 
                    this.user_structure = {}
                    this.document = {
                        categoryId: 0,
                        cc: [],
                        send_after_sign: [],
                        priority: {},
                        privacy: {},
                        importance: {},
                        externalReferenceNumber: '',
                        date: '',
                        subject: '',
                        dueDate: '',
                        translatedSubject: '',
                        keywords: '',
                        otherAttachments: '',
                        signers: [],
                        formData: {},
                        purposeId: 0,
                        secretForward: false,
                        purposeIdBeforeRevoke: 0,
                        project: '',
                        projectNumber: '',
                        statusId: null,
                        isNeedReply: null,
                        replyDocument: null,
                        tags: [],
                        documentType: {},
                        documentTypeId: null,
                        byTemplate: null,
                        isDispatched: false,
                        referenceSequenceType:0
                    }
                this.subject = ''
                }
            },
            transferId() {
                if (this.transferId > 0)
                    this.getDocumentWithTransfer()
                else
                    this.transfer = {}
            },
            'document.receiversAndDesignatedPersons':function(val){
            },
            'document.date': function () {               
                if (this.document.date != null && this.document.date != '' && this.document.date != undefined)
                    this.formattedDate = utils.dateFormat(this.document.date)
                else {
                    this.document.date = new Date().toISOString().slice(0, 10)
                    this.formattedDate = utils.dateFormat(new Date().toISOString().slice(0, 10))
                }
            },
            'document.dueDate': function () {
                if (this.document.dueDate != null && this.document.dueDate != '' && this.document.dueDate != undefined)
                    this.formattedDueDate = utils.dateFormat(this.document.dueDate)
                else {
                    this.document.dueDate = new Date().toISOString().slice(0, 10)
                    this.formattedDueDate = utils.dateFormat(new Date().toISOString().slice(0, 10))
                }
            },
            'document.receivedDate': function () {
                if (this.document.receivedDate != null && this.document.receivedDate != '' && this.document.receivedDate != undefined)
                    this.formattedReceivedDate = utils.dateFormat(this.document.receivedDate)
                else {
                    this.document.receivedDate = new Date().toISOString().slice(0, 10)
                    this.formattedReceivedDate = utils.dateFormat(new Date().toISOString().slice(0, 10))
                }
            }
        },
        methods:
        {
            openDefaultSignerMethod()
            {
                axios.post(constants.baseApiUrl + 'StructureUser/GetDefaultSignerMethod', null)
                    .then(response => 
                    {
                        if (response.data != null)
                        {
                            this.allowESignature = response.data.allowESignature,
                            this.allowUAEPASSSignature = response.data.allowUAEPASSSignature
                        }
                    }).catch(err => console.warn(err))
                    .finally(()=> window.hideLoading())
            },
            getTransferNotesCount(count)
            {
                if(count > 0)
                    this.multipleTransferNotesExist = true;
            },
            closeNotifyEmail()
            {
                this.notifyEmailDialogCorrespondence = false;
            },
            isDelegatedDocument()
            {
                if(this.toUserId && this.userId && this.toUserId !== this.userId )
                {
                    if(this.toUserId != this.userId)
                    {
                        return true;
                    }
                    else
                    {
                        return false;
                    }
                }
                else
                {
                    return false;
                }
            },
            onDispatchResultClosed()
            {
                // Only leave the correspondence when it is fully dispatched. On a warning, or when some
                // recipients failed, the user stays here so they can retry.
                if (!this.dispatchResultWarning && this.failedEntities.length == 0)
                    this.closeDialog();

                this.dispatchResultWarning = ''
            },
            DispatchCorrespondenceToEntities()
            {
                window.showLoading();

                var methodUrl = 'Dispatch/DispatchCorrespondenceForAll?documentId=' + this.documentId+'&transferId='+ this.transferId
                axios.post(constants.baseApiUrl + methodUrl, { headers: constants.headers })
                    .then(res => 
                    {
                        window.hideLoading()
                        if (res.data != null && res.data.result === true)
                        {
                            this.dispatchCorrespondenceFormDialog = false;
                            this.dispatchResultWarning = ''
                            this.dispatchedEntities = res.data.dispatchedEntities || []
                            this.viaEmailEntities = res.data.viaEmailEntities || []
                            this.failedEntities = []

                            this.dispatchResultDialog = true;
                        }
                        else if(res.data != null && res.data.result === false && res.data.status == 409) {
                            this.dispatchCorrespondenceFormDialog = false;
                            this.dispatchedEntities = []
                            this.viaEmailEntities = []
                            this.failedEntities = []
                            this.dispatchResultDialog = false;
                            window.showAlert('res_Msgs_CorrespondenceAlreadyDispatched', 'warning')
                        }
                        else if(res.data != null && res.data.result === false && res.data.status == 500
                                 && (res.data.failedEntities || []).length > 0) {
                            this.dispatchCorrespondenceFormDialog = false;
                            this.dispatchResultWarning = ''
                            this.dispatchedEntities = res.data.dispatchedEntities || []
                            this.viaEmailEntities = res.data.viaEmailEntities || []
                            this.failedEntities = res.data.failedEntities || []

                            this.dispatchResultDialog = true;
                        }
                        else if(res.data != null && res.data.result === false && res.data.status == 500) {
                            window.showAlert(res.data.message, 'warning')
                        }
                        else {
                            window.showAlert(res.data.message, 'warning')
                        }
                    })
                    .catch(err => console.warn(err))
            },
            isActionOverflowed(actionKey)
            {
                return this.overflowedActionKeys.indexOf(actionKey) != -1;
            },
            actionClass(actionKey)
            {
                return { 'action-overflowed': this.isActionOverflowed(actionKey) };
            },
            resetShowButtons()
            {
                this.overflowedActionKeys = [];
                this.$nextTick(this.measureFooterButtons);
            },
            measureFooterButtons()
            {
                var footer = this.$el ? this.$el.querySelector('.rowContainer') : null;
                var row = this.$refs.actionsRow;

                // footer not rendered yet, or not visible
                if (footer == null || row == null || footer.clientWidth == 0) return;

                var buttons = Array.prototype.slice.call(row.querySelectorAll('[data-action-key]'));

                // 1. show every button so it reports its real width
                buttons.forEach(function (btn) { btn.classList.remove('action-overflowed'); });

                // 2. space taken by what never collapses
                var notesIcon = this.$refs.transferNotesIcon;
                var moreBtn = footer.querySelector('.more-btn');
                var footerStyle = window.getComputedStyle(footer);
                var reserved = 20 // breathing room
                    + (parseFloat(footerStyle.paddingLeft) || 0)
                    + (parseFloat(footerStyle.paddingRight) || 0);
                if (notesIcon && notesIcon.$el) reserved += notesIcon.$el.offsetWidth;
                if (moreBtn) reserved += moreBtn.offsetWidth;

                // 3. keep the buttons that fit, the rest go to More Actions.
                //    used only grows, so everything after the first miss overflows too.
                var available = footer.clientWidth - reserved;
                var used = 0;
                var overflowed = [];

                buttons.forEach(function (btn)
                {
                    used += btn.offsetWidth + 10; // 10 = .margin-left-m
                    if (used > available) overflowed.push(btn.getAttribute('data-action-key'));
                });

                // 4. hide them again now, before the browser paints
                buttons.forEach(function (btn)
                {
                    if (overflowed.indexOf(btn.getAttribute('data-action-key')) != -1)
                        btn.classList.add('action-overflowed');
                });

                this.overflowedActionKeys = overflowed;
            },
            UndoArchive(document)
            { 
                axios.post(`${constants.baseApiUrl}Document/UndoArchiveDocument?transferId=${document.transferId}`)
                    .then(res => {
                        if (res.data && res.data.success == true) {
                            // let TransferredTo = res.data.transferredTo; 
                            let message = this.$t('res_Message_UndoArchiveSuccess'); 
                            window.showAlert(message, 'success');
                            this.closePreview();
                            this.closeDialog(false, false);
                        }
                        else {
                            window.showAlert('res_Message_UndoArchiveFail', 'warning');
                        }
                    })
                    .catch(err => console.warn(err))
            },
            completeTransfer(document)
            { 
                window.showInformation(this.$t('res_Msgs_Confirmation'), this.$t('res_Msgs_CompleteCorrespondence'),
                    () => 
                    {
                        axios.post(`${constants.baseApiUrl}Transfer/Complete?transferId=${document.transferId}`)
                            .then(res => 
                            {
                                if (res.data != null && res.data.length > 0) 
                                {
                                    let referenceNumber = res.data.join(', ');
                                    
                                    let message = this.$t('res_Message_CompleteSuccess', {referenceNumber}); 
                                    window.showAlert(message, 'success');
                                    this.closeDialog(false, false);
                                }
                                else 
                                {
                                    window.showAlert('res_Message_CompleteFail', 'warning');
                                }
                            })
                            .catch(err => console.warn(err))
                    },
                    () => {});
            },
            async fetchCanSignWithoutPin() 
            {
                try 
                {
                    var response = await axios.get(constants.baseApiUrl + 'User/GetCanSignWithoutPinCode');
                    return response.data && this.enableSignWithOutPinCodeFeature;
                } 
                catch (error) 
                {
                    console.log(error);
                    return false;
                }
            },
            disableQrCode()
            {
                axios.post(constants.baseApiUrl + 'Document/DisableQrCode?documentId=' + this.documentId)
                    .then(res => {
                        if (res.data == 1) {
                            window.showAlert('res_Msgs_QrCodeDisabled', 'success')
                            this.qrCodeEnabled = false;
                        }
                        else {
                            window.showAlert('res_Msgs_ErrorOccured', 'warning')
                        }
                    })
                    .catch(err => console.warn(err))
            }, 
            closeGenerateAdvanceDialog()
            {
                this.showGenerateAdvance = false;
                this.signers_GenerateReferenceNumberAdvance = [];
                this.style_generateReferenceNumber = {
                    maxHeight: '1000px',
                    overflowY: 'auto'
                };
            },
            performAction(action) 
            {
                if (action === 'Upload')
                    this.$refs.attachmentCtrl.uploadAttachment()
                else if (action === 'Scan')
                    this.openScanDialog = true

                this.isMenuOpen = false
            },
            truncateFilename(filename, maxLength) {
                maxLength=70
                // Find the last dot (.) in the filename to split into name and extension
                const lastDotIndex = filename.lastIndexOf('.');

                // If no dot is found or it's the first character (hidden file), return the original filename
                if (lastDotIndex <= 0) {
                    return filename;
                }

                // Split into name and extension
                const name = filename.slice(0, lastDotIndex);
                const extension = filename.slice(lastDotIndex);

                // Truncate the name part to maxLength characters
                const truncatedName = name.slice(0, maxLength);

                // Combine truncated name with extension
                const truncatedFilename = truncatedName + extension;

                return truncatedFilename;
            },
            printWithAttachmentWithStamps() 
            {
                utils.PrintFile(constants.baseApiUrl + 'ViewerActions/DownloadWithAnnotation?id=' + this.attachmentId, this.truncateFilename(this.document.subject + '.pdf', 100) )
            },
            printwithoutsignture()
            {
                utils.PrintFile(constants.baseApiUrl + 'Document/Downloadwithoutheaderandsignture?documentId=' + this.documentId+'&removeSignature=true', this.truncateFilename(this.document.subject + '.pdf', 100))
            },
            printwithoutHeader()
            {
                utils.PrintFile(constants.baseApiUrl + 'Document/Downloadwithoutheaderandsignture?documentId=' + this.documentId+'&removeHeader=true', this.truncateFilename(this.document.subject + '.pdf', 100))
            },
            closeNewTrackerDialog()
            { 
				this.visualTrackingDialogNew = false;
		    }, 
            cancelFollowup() {
            window.showInformation(window.translate("res_Msgs_Confirmation"), window.translate("res_Msgs_FollowUpCancelConfirmation"),
                () => {
                    var methodUrl = "Followup/CancelFollowup?transferId=" + this.transferId
                    axios.post(constants.baseApiUrl + methodUrl, null, { headers: constants.headers })
                        .then(() => {
                            window.showAlert("res_Msgs_FollowUpCancellation", 'success')
                            this.closeDialog(false,false)
                        })
                        .catch(err => console.warn(err))
                },
                () => { })
        },
            ReminderByEmail() 
            {
                if (this.reminderToDate == '') {
                    window.showAlert(this.$t('res_Msgs_FillRequired'), 'warning')
                    return
                }
                window.showLoading();
                axios.post(constants.baseApiUrl + 'Transfer/ReminderByEmail?transferId=' + this.transferId + '&toDate=' + this.reminderToDate + '&toEmails=' + this.fromEmail)
                    .then((res) => {
                        if (res.data == false) {
                            window.showAlert(this.$t('res_Msgs_TransferNotFound'), "warning")
                        }
                        window.showAlert(this.$t('res_Msgs_ReminderAlert'), 'success')
                        this.reminderEmailDialog = false;
                        this.reminderToDate = '';
                        this.hideToDateMenu = false;
                        this.closeDialog(false,false)
                    })
                    .catch((err) => { console.log(err); })
                    .finally(()=>{ window.hideLoading(); })
            },
            downloadCorrespondence(value)
            {
                this.withAttachments = value;
                var methodUrl = 'Document/Download?documentId=' + this.documentId
                if (this.withAttachments)
                    methodUrl = 'Document/DownloadWithAttachments?documentId=' + this.documentId
                
                utils.DownloadFile(constants.baseApiUrl + methodUrl, this.truncateFilename(this.document.subject + '-' + this.document.referenceNumber + '.pdf', 100))
            },
            sendCorrespondence(value) 
            {
                this.withAttachments = value;
                this.selectedDocumentId = this.documentId
                this.emailDispatchDocumentDialog = true
            },
            openMultiSelectCtrl(id) 
            {
                if (id === 1) this.$refs.multiselect1.activate()
                else if (id === 2) this.$refs.multiselect2.activate()
                else if (id === 3) this.$refs.multiselect3.activate()
                else if (id === 4) this.$refs.multiselect4.activate()
                else if (id === 5) this.$refs.multiselect5.activate()
                else if (id === 7) this.$refs.multiselect7.activate()
                // for AdPorts
                else if (id === 15) this.$refs.multiselect15.activate()
                // for adha
                else if (id === 21) this.$refs.multiselect21.activate()
            },
            closeCorrespondenceDialog() {
                this.dialogCount--;
                if (this.dialogCount == 1)
                    this.viewMode = 'edit'
                this.correspondenceDialog = false
            },
            closeTransferFormDialog() {
                this.closeDialog(false, false);
            },
            CreateReplyLetter(){
                this.createReplyDocumentEvent(this.documentId)
            },
            closeDialog(isBack = false, checkForShowConfirmation = true) 
            {              
                this.overflowedActionKeys = [];

                function close(context, isBack) {
                    // if (isBack)
                    //     context.closeDialogEvent(context)
                    // else
                    context.closeDialogEvent('')
                }

                var showConfirmation = false
                if (checkForShowConfirmation) {
                    if (this.viewMode == "edit")
                        showConfirmation = true
                }

                if (showConfirmation) {
                    window.showInformation(
                        window.translate("res_Msg_Close"),
                        isBack ? window.translate("res_Msgs_BackConfirmation") : window.translate("res_Msgs_CloseDocumentConfirmation"),
                        () => {
                            close(this, isBack);
                        },
                        () => { });
                }
                else
                    close(this, isBack)
            },
            fillSenderRecipientDesignatedPersonsData(obj) 
            {
                if (obj != null) 
                {
                    this.$set(this.document, 'sendingEntityId', obj.selectedSenderStructureId != null ? obj.selectedSenderStructureId : null);
                    this.$set(this.document, 'sendingDesignatedPersonId', obj.selectedSendingDesignatedPersonId != null ? obj.selectedSendingDesignatedPersonId : null);
                    this.document.compoRecipientDesignatedPersons = []
                    this.$set(this.document, 'compoRecipientDesignatedPersons', obj.compoRecipientDesignatedPersons);
                }
            },
            getUserStructures() 
            {
                return axios.post(constants.baseApiUrl + 'StructureUser/GetCurrentUserStructures', null)
                    .then(response => 
                    {
                        this.user_structures = response.data;
                        if (this.user_structures.length > 0)
                            { 
                                this.user_structure = this.user_structures.find(s=>s.isDefaultStructure == true);
                                if(this.user_structure == null)
                                { this.user_structure = this.user_structures[0];}
                            }
                    })
                    .catch(error => console.log(error))
                    .finally(() => this.loading = false);
            },
            getLookupItems() 
            {
                this.priority_items = constants.priorities
                this.privacy_items = constants.privacies
                this.importance_items = constants.importancies 
                this.messageType_items = constants.messageTypes
                this.document.priority = this.priority_items[0]
                this.document.privacy = this.privacy_items[0]
                this.document.importance = this.importance_items[0]

                if (constants.showDocumentType)
                {
                    this.documentType_items = constants.documentTypes
                    this.document.documentType = this.documentType_items[0]
                }
            },
            getTemplateDescription(templateId, signersList) 
            {
                this.selectedTemplate = null
                window.documentView.template_signatureCount = 0
                window.documentView.template_signersList = []
                utils.defaultGet('Template/GetTemplateDescription?Id=' + templateId, (res) => {
                    if (res.data != null && res.data != undefined) 
                    {
                        this.selectedTemplate = res.data
                        constants.isUAEPassEnabledTemplate = this.selectedTemplate.isUAEPassEnabled ;
                        constants.isEsealEnabledTemplate = this.selectedTemplate.isEsealEnabled ;

                        window.documentView.template_isWorkflow = this.selectedTemplate.isWorkflow

                        if ((this.document.categoryId == 3 && this.selectedTemplate.isWorkflow == true)) {
                            if (signersList == null || signersList == undefined || signersList.length == 0) {
                                // check if you have predefined signers
                                var predefinedSigners = this.selectedTemplate.signatoryList
                                if (predefinedSigners != null && predefinedSigners != undefined && predefinedSigners != '') {
                                    var signatoryUserIds = ''
                                    var signatoryList = predefinedSigners.split('|').filter(e => e);
                                    for (var i = 0; i < signatoryList.length; i++) {
                                        signatoryUserIds += "'" + signatoryList[i].split('#')[0] + "',"
                                    }

                                    // remove last comma if exists
                                    if (signatoryUserIds.endsWith(','))
                                        signatoryUserIds = signatoryUserIds.substring(0, signatoryUserIds.length - 1)

                                    utils.defaultGet('StructureUser/GetUsersForMultiSelect?userIds=' + signatoryUserIds, (res) => {
                                        if (res != undefined && res.data != null && res.data != undefined) {
                                            this.document.signers = res.data
                                            if (res.data.length == this.selectedTemplate.signatureCount)
                                                this.signerSelectionEnabled = false
                                            else {
                                                var predefinedSignersCount = res.data.length
                                                for (var i = 0; i < this.selectedTemplate.signatureCount - predefinedSignersCount; i++)
                                                    this.document.signers.push({ index: res.data.length + i + 1 })
                                            }
                                            window.documentView.template_signersList = this.document.signers
                                        }
                                    }, this.handleError, true);
                                }
                                else {
                                    for (var i = 0; i < this.selectedTemplate.signatureCount; i++)
                                        this.document.signers.push({ index: i + 1 })

                                    this.signerSelectionEnabled = true
                                }
                            }
                            else {
                                this.document.signers = signersList
                                window.documentView.template_signersList = signersList

                                this.signerSelectionEnabled = true
                                if (this.splitAndRemoveEmpty(this.selectedTemplate.signatoryList, '|').length == signersList.length)
                                    this.signerSelectionEnabled = false
                            }
                        }

                        window.documentView.template_signatureCount = this.selectedTemplate.signatureCount
                    }
                },
                    this.handleError, true);
            },
            splitAndRemoveEmpty(input, delimiter) {
                if (input == null) {
                    return [];
                }
                const filteredParts = input.split(delimiter).filter(part => part.trim() !== '');
                return filteredParts;
            },
            handleError(error) {
                this.loading = false
                console.log(error)
                window.showAlert('res_Msgs_ErrorOccured', 'error')
            },
            attachmentExtensionChanged(extension)
            {
                this.selectedAttachmentExtension = extension;
            },
            reloadDocument()
            {
                if(this.transferId != null && this.transferId != undefined && this.transferId != 0)
                {
                    
                    this.getDocumentWithTransfer();
                }
            },
            viewerPageModeParam()
            {
                return this.canEditDocumentMetaData() ? '&pageMode=edit' : '&pageMode=view';
            },
            setViewerUrl(attachmentId)
            {
                this.attachmentId = attachmentId;
                if (attachmentId != 0) {
                    var transferId = this.transferId == 0 ? '' : this.transferId
                    this.empty_viewer = false

                    var viewerMode = this.viewerPageModeParam()

                    if(this.viewingLinkedDocument)
                        this.openedFromNodeId = -1

                    window.setViewerData(attachmentId, this.documentId, null, this.document.subject + '-' + this.document.referenceNumber, this.document.openedByCreator);
                    var templateId=this.document.templateId;
                    if (this.document.createdDate != "" && this.document.createdDate != null && this.document.createdDate != undefined) {
                        var date = this.document.createdDate.split(' ')
                        this.viewerFrameSrc = '/resources/viewer/viewer.html?templateId='+templateId+'&lang=' + this.$i18n.locale + '' + viewerMode + '&r=' + new Date().getTime() + '' + '&statusId=' + this.statusId + '' + '&createdDate=' + date[0] + '' + '&time=' + date[1] + '&delegationId=' + this.delegationId + '&hideEditInWord=' + this.hideEditInWord
                    }
                    else {
                        this.viewerFrameSrc = '/resources/viewer/viewer.html?templateId='+templateId+'&lang=' + this.$i18n.locale + '' + viewerMode + '&r=' + new Date().getTime() + '' + '&statusId=' + this.statusId + '&delegationId=' + this.delegationId + '&hideEditInWord=' + this.hideEditInWord
                    }
                }
                else {
                    this.empty_viewer = true
                    this.viewerFrameSrc = ''
                }
            },
            refreshViewer(withEdit)
            { 
                if (this.viewerFrameSrc != '') {
                    var viewerMode = this.viewerPageModeParam()
                        var templateId=this.document.templateId;
                        if (this.document.createdDate != "" && this.document.createdDate != null && this.document.createdDate != undefined) {
                        var date = this.document.createdDate.split(' ')
                        this.viewerFrameSrc = '/resources/viewer/viewer.html?templateId='+templateId+'&lang=' + this.$i18n.locale + '' + viewerMode + '&r=' +  Math.floor(new Date().getTime() / 1000) + '' + '&statusId=' + this.statusId + '' + '&createdDate=' + date[0] + '' + '&time=' + date[1] + '&hideEditInWord=' + this.hideEditInWord
                    }
                    else {
                        this.viewerFrameSrc = '/resources/viewer/viewer.html?templateId='+templateId+'&lang=' + this.$i18n.locale + '' + viewerMode + '&r=' +  Math.floor(new Date().getTime() / 1000) + '' + '&statusId=' + this.statusId + '&hideEditInWord=' + this.hideEditInWord
                    }
                    this.empty_viewer = false
                    sessionStorage.setItem('editInWord' , `${withEdit}`);
                    this.viewerFrameSrc = this.viewerFrameSrc + '&editInWord=' + withEdit + '&refresh=' + Math.random()
                }
            },
            documentCCSelectedChange(items) {
                this.$set(this.document, 'cc', items);
            },
            documentRequestingSelectedChange(items) {
                this.$set(this.document, 'requestingDepatment', items);
            },
            documentSendAfterSignSelectedChange(items) {
                this.$set(this.document, 'send_after_sign', items);

            },
            replyDocumentSelectedChange(item) {
                this.$set(this.document, 'replyDocument', item);
            },

            documentSigneeSelectedChange(item, index) {
                if (item == null) {
                    this.$set(this.document.signers, index, {});
                    return;
                }
                const checkDuplicateUser = this.document.signers.some(x => x && x.id == item.id);
                if (checkDuplicateUser) {
                    this.document.signers.splice(index, 1); 
                    window.showAlert(this.$t('res_Msgs_UserAlreadyAdded'), 'warning');
                    return;
                } 

                this.$set(this.document.signers, index, item);
            },
            GenerateAdvance_documentSigneeSelectedChange(item, index) {
                this.$set(this.signers_GenerateReferenceNumberAdvance, index, item || {});
            },
            addNewSignee_GenerateReferenceNumberAdvance() {
                this.signers_GenerateReferenceNumberAdvance.push({});
                this.style_generateReferenceNumber = {
                    maxHeight: '1000px',
                    overflowY: 'auto',
                    height: '300px'
                };
            },
            addNewSignee() 
            {
                this.collapseSigners = false   
                this.document.signers.push({})
                window.documentView.template_signatureCount = this.document.signers.length
            },
            deleteSignee(indexToRemove)
            {
                this.document.signers.splice(indexToRemove, 1);
            },
            deleteSignee_GenerateReferenceNumberAdvance(indexToRemove)
            {
                this.signers_GenerateReferenceNumberAdvance.splice(indexToRemove, 1);
                if(this.signers_GenerateReferenceNumberAdvance.length == 0)
                {
                    this.style_generateReferenceNumber = {
                        maxHeight: '1000px',
                        overflowY: 'auto'
                    };
                }
            },
            priorityChanged(item) {        
                let today = new Date(); // create a new Date object with today's date
                let daysLater = new Date(today.getTime() + item.numberOfDueDays * 24 * 60 * 60 * 1000); // add 15 days to the current date
                
                if (this.document.date == '' || this.document.date == null || this.document.date == undefined) {
                    this.document.date = new Date().toISOString().slice(0, 10);
                }
                    
                this.document.dueDate = daysLater.toISOString().slice(0, 10)
            },
            fillDocumentDataForEdit(item) 
            {
                this.document.categoryId = item.categoryId
                this.document.referenceNumber = item.referenceNumber
                this.document.createdDate = item.createdDate
                this.document.canSign = item.canSign
                this.document.secretForward = item.secretForward
                this.document.statusId = item.statusId

                if (item.carbonCopies != null && item.carbonCopies != undefined && item.carbonCopies.length > 0) 
                {
                    var carbonCopyObjects = JSON.parse(item.carbonCopies)

                    var ccItems = []
                    carbonCopyObjects.forEach(function (cc) {
                        ccItems.push({ id: cc.id, name: cc.text, isUser: (carbonCopyObjects[0].id.lastIndexOf('-') != -1) })
                    });

                    this.document.cc = ccItems
                }

                if (this.messageType_items != null && this.messageType_items.length > 0)
                {  
                    if (typeof(item.messageType) != 'undefined' && item.messageType != null)
                        this.document.messageType = this.messageType_items.find(x => x.Id == item.messageType)
                    // else
                    //     this.document.messageType = this.messageType_items[0]  
                } 

                if (item.priorityId != null)
                    this.document.priority = this.priority_items.find(x => x.id == item.priorityId)
                else 
                {
                    this.document.priority = this.priority_items[0]
                    this.priorityChanged(this.document.priority)
                }

                if (item.privacyId != null)
                    this.document.privacy = this.privacy_items.find(x => x.id == item.privacyId)
                else
                    this.document.privacy = this.privacy_items[0]

                if (item.importanceId != null)
                    this.document.importance = this.importance_items.find(x => x.id == item.importanceId)
                else
                    this.document.importance = this.importance_items[0]

                if (constants.showDocumentType)  
                 {                 
                    if (item.documentTypeId != null)
                        this.document.documentType = this.documentType_items.find(x => x.id == item.documentTypeId)
                     else                 
                         this.document.documentType = this.documentType_items[0]    
                }

                if (item.externalReferenceNumber != null)
                    this.document.externalReferenceNumber = item.externalReferenceNumber

                if (item.dueDate != null && item.dueDate != undefined)
                    this.document.dueDate = item.dueDate

                if (item.subject != null) 
                {
                    this.document.subject = item.subject
                    this.subject = item.subject
                }

                var selectedUserStructure = this.user_structures.find(s => s.structureId == item.createdByStructureId)
                if (selectedUserStructure != null)
                    this.user_structure = selectedUserStructure

                var formDataObj = JSON.parse(item.formData);
                this.document.formData = item.formData;

                if (formDataObj != null) 
                {
                    if (this.viewIncomingAddedFields && typeof(formDataObj.receivedDate) != 'undefined' && formDataObj.receivedDate != '')
                    {
                        this.document.receivedDate = formDataObj.receivedDate
                    }  

                    if (typeof(formDataObj.messageTypeId) != 'undefined' && formDataObj.messageTypeId != '')
                    {
                        this.document.messageType = this.messageType_items.find(s=>s.Id == formDataObj.messageTypeId);
                    }    
                    
                    if (typeof(formDataObj.multiDocument) != 'undefined')
                    {
                        if(formDataObj.multiDocument == true) {this.multiDocument = '1';}
                        else {this.multiDocument = '0';} 
                    }    
                   
                    if (typeof(formDataObj.documentDate) != 'undefined' && formDataObj.documentDate != '') 
                    {
                        this.document.date = formDataObj.documentDate
                    }

                    this.document.translatedSubject = formDataObj.translatedSubject

                    this.document.amount = formDataObj.amount

                    this.document.requestingDepatment = formDataObj.requestingDepartment

                    this.document.keywords = formDataObj.keywords

                    this.document.otherAttachments = formDataObj.otherAttachments

                    this.documentSignersBackup = formDataObj.signers
                    this.document.send_after_sign = formDataObj.sendAfterSign

                    if (formDataObj && formDataObj.templateId != '')
                        this.getTemplateDescription(formDataObj.templateId, JSON.parse(formDataObj.signers))

                }

                if (item.attachmentId != null)
                    this.setViewerUrl(item.attachmentId)

                this.document.canSign = item.canSign
                this.document.isRegistered = item.isRegistered
                this.document.cCed = item.cCed

                if (this.document.cc && this.document.cc.length > 0)
                    this.showCCBlock = true;

                window.documentView.document = this.document
            },
            async getDocumentWithTransfer(afterSave = false) {
                try {   
                    
                    const response = await axios.get(constants.baseApiUrl + 'Transfer/GetDocumentTransferInfo?documentId=' + this.documentId + '&transferId=' + this.transferId + '&delegationId=' + this.delegationId); 
                    this.document = utils.copyObject(response.data[0], this.document);
                    this.getEditSignedPermissionRecordFlag();
                    this.qrCodeEnabled = this.document.isQrCodeEnabled;
                    this.statusId = this.document.statusId;
                    let templateInfoList = (this.document.templateInfo != null && this.document.templateInfo != undefined && this.document.templateInfo != '' ? JSON.parse(this.document.templateInfo) : '');
                    if (templateInfoList != '' && templateInfoList.templateData && templateInfoList.templateData.length > 0) {
                        let infoItem = templateInfoList.templateData[0];
                        this.templateInfo = {
                            Id: infoItem.Id,
                            Name: (infoItem.Name == null || infoItem.Name == undefined ? this.$t('res_Label_NotDefined') : infoItem.Name),
                            Description: infoItem.Description,
                            Language: (infoItem.Language == null || infoItem.Language == undefined ? this.$t('res_Label_NotDefined') : infoItem.Language),
                            SignatureCount: (infoItem.SignatureCount == null || infoItem.SignatureCount == undefined ? 0 : infoItem.SignatureCount),
                            Tags: (infoItem.Tags == null || infoItem.Tags == undefined ? "" : infoItem.Tags)
                        };
                    }
                    this.classificationPlanIdRequired = (this.document.categoryId == constants.categories_Helper_Enum.Outgoing.value || this.document.categoryId == constants.categories_Helper_Enum.Internal.value) && constants.client_version_Id == 'NLA';
                    this.viewIncomingAddedFields = this.document.categoryId == constants.categories_Helper_Enum.Incoming.value;
                    this.viewInternalAddedFields = this.document.categoryId == constants.categories_Helper_Enum.Internal.value;
                    this.viewOutgoingAddedFields = this.document.categoryId == constants.categories_Helper_Enum.Outgoing.value && constants.viewMultiDocumentOption;
                    sessionStorage.setItem("documentIsSigned", this.document.isSigned);
                    this.document.tags = [];
                    if (response.data[0].tags != null) {
                        var assignedTags = JSON.parse(response.data[0].tags);
                        for (var i = 0; i < assignedTags.length; i++) {
                            this.document.tags.push(assignedTags[i]);
                        }
                    }

                    this.subject = this.document.subject;
                    let documentForm = JSON.parse(this.document.formData);

                    if (documentForm != null) {
                        if (documentForm && documentForm.signers && documentForm.signers != null) {
                            this.documentSignersBackup = JSON.stringify(JSON.parse(this.document.formData).signers);
                            this.document.signers = JSON.parse(JSON.parse(this.document.formData).signers);
                            if (this.document.signers.length > 0)
                                this.collapseSigners = false; 
                                this.$nextTick(() => {  
                                    this.showConfigureSignatures = this.document.signers.some(signer => signer.name.trim() !== '');    
                                });  
                        }

                        if (typeof (documentForm.documentDate) != 'undefined' && documentForm.documentDate != '') {
                            this.document.date = documentForm.documentDate;
                        }

                        if (documentForm.hrmsEmployee != null && documentForm.hrmsEmployee != undefined) {
                            var hrmsEmployee = constants.hrmsEmployeeList.find(x => x.id == documentForm.hrmsEmployee);
                            if (hrmsEmployee != null && hrmsEmployee != undefined)
                                this.document.hrmsEmployee = hrmsEmployee;
                        }
                    }

                    if (response.data[0] != null && response.data[0].sendingEntityId != undefined)
                        this.document.sendingEntityId = JSON.parse(response.data[0].sendingEntityId);
                    // else
                    //     this.document.sendingEntityId = null;

                    if (response.data[0] != null && response.data[0].sendingDesignatedPersonId != undefined)
                        this.document.sendingDesignatedPersonId = JSON.parse(response.data[0].sendingDesignatedPersonId);
                    else
                        this.document.sendingDesignatedPersonId = null;

                    if (response.data[0] != null && response.data[0].receiversAndDesignatedPersons != undefined)
                        this.document.receiversAndDesignatedPersons = JSON.parse(response.data[0].receiversAndDesignatedPersons);

                    if (response.data[0] != null && (response.data[0].isNeedReply == true || response.data[0].isNeedReply == false))
                        this.document.isNeedReply = response.data[0].isNeedReply;

                    if (response.data[0] != null && response.data[0].replyDocument != undefined) {
                        let replyDoc = JSON.parse(response.data[0].replyDocument);
                        if (replyDoc.replyDocument != undefined && replyDoc.replyDocument != null && Object.keys(replyDoc.replyDocument).length !== 0) {
                            this.document.replyDocument = JSON.parse(replyDoc.replyDocument);
                            this.document.replyDocument.formattedLabel = this.document.replyDocument.subject + " - " + this.document.replyDocument.ReferenceNumber;
                            this.showReplyDocumentSection = true;
                        }
                        else
                            this.showReplyDocumentSection = false;
                    }
                    else
                        this.showReplyDocumentSection = false;


                    if (response.data[0] != null && response.data[0].filingPlan != undefined) {
                        this.document.filingPlan = JSON.parse(response.data[0].filingPlan);
                    }
                    else
                        this.document.filingPlan = null;

                    if (response.data[0] != null && response.data[0].classificationPlan != undefined)
                        this.document.classificationPlan = JSON.parse(response.data[0].classificationPlan);
                    else
                        this.document.classificationPlan = null;

                    window.documentView.document = this.document;

                    if ((this.openedFromNodeId == 2 || this.openedFromNodeId == 10) && (this.document.openedDate == null || !this.document.toUserId))
                    {
                        await axios.post(constants.baseApiUrl
                                        + 'Transfer/MarkTransferAsReadAndLock?transferId='
                                        + this.transferId + '&delegationId=' +
                                        this.delegationId + '&nodeId=' +
                                        this.openedFromNodeId, null)
                        .catch(error => console.log(error));
                    }

                    // if (this.canEditDocumentMetaData())
                    this.fillDocumentDataForEdit(response.data[0]);

                    if (this.document.attachmentId != null)
                        this.setViewerUrl(this.document.attachmentId);

                    var formDataObj = JSON.parse(response.data[0].formData);

                    if (formDataObj != undefined && formDataObj != null && typeof (formDataObj.messageTypeId) != 'undefined' && formDataObj.messageTypeId != '') {
                        this.document.messageType = this.messageType_items.find(s => s.Id == formDataObj.messageTypeId);
                    }

                    var context = this;
                    setTimeout(() => {
                        if (context.$refs.transferNotesIcon)
                            context.$refs.transferNotesIcon.showTransferNotes(this.document.fromUserId, this.document.instruction, this.documentId);
                    }, 50);

                    this.disableAdvancedTransfer = !this.document.isSigned;
                    this.isSecretNote = this.document.isSecretNote;
                    this.toUserId = this.document.toUserId;
                    this.fromUserId = this.document.fromUserId;

                    if (window.afterDocumentLoaded != null && window.afterDocumentLoaded != undefined)
                        window.afterDocumentLoaded(this.document, this.transferId, this.delegationId, this.viewMode);

                    // hide advanced force generate reference number for internal as internal don't have signer code in AdPorts case
                    // hide normal force generate reference number for outgoing
                    if (this.document.categoryId == 3)
                        this.showAdvanceForceGenerateRF = false;
                    else if (this.document.categoryId == 2)
                        this.showNormalForceGenerateRF = false;

                    setTimeout(() => {
                        this.resetShowButtons();
                    }, 50);
                    this.resetShowButtons();
                    this.startButtonRendering = true;

                    if (this.document.categoryId != 4 && this.document.categoryId != 5) {
                        if(afterSave && !this.document.recipientHasDesignatedPersons)
                                setTimeout(() => {
                                    window.showAlert("res_Msgs_RecipientHasNoDesignatedPersons", 'warning')
                                }, 3000);
                    }
                } 
                catch (error) 
                {
                    console.log(error);
                }
            },
            prepareFormDataObject(isRegister)
            {  
                var templateId = '';

                if (this.document.formData != undefined) 
                {
                    var formDataObj = JSON.parse(this.document.formData);
                    if (formDataObj != null && formDataObj.templateId != undefined)
                        templateId = formDataObj.templateId;
                }

                if (this.document.signers != null && this.document.signers != undefined && this.document.signers.length > 0)
                    this.document.signers.forEach((item) => {
                        item.index = this.document.signers.indexOf(item) + 1
                    });

                
                var model = new FormData();
                model.append('id', this.documentId);
                model.append('categoryId', this.document.categoryId);
                model.append('subject', this.document.subject.trim());
                model.append('formData', JSON.stringify({
                    "translatedSubject": this.document.translatedSubject.trim(),
                    "keywords": this.document.keywords,
                    "otherAttachments": this.document.otherAttachments.trim(),
                    "templateId": templateId,
                    "signers": JSON.stringify(this.document.signers),
                    "documentDate": this.document.date,
                    "hrmsEmployee": (this.document.hrmsEmployee == null || this.document.hrmsEmployee == "") ? '' : this.document.hrmsEmployee.id,
                    
                    "project": (this.document.project == null || this.document.project == "") ? '' :this.document.project.Id,
                    "projectNumber":(this.document.projectNumber == null || this.document.projectNumber == "") ? '' : this.document.projectNumber.Id,
                    "sendAfterSign": this.document.send_after_sign,
                    "workflowId": '',
                    "receivedDate": this.document.receivedDate,
                    "messageTypeId": (this.document.messageType == null || this.document.messageType == "") ? '' : this.document.messageType.Id,
                    "multiDocument": this.multiDocument == 1 || this.multiDocument == '1',
                    "requestingDepartment":this.document.requestingDepatment,
                    "amount": this.document.amount,
 
                }));
               
                if (this.document.sendingEntityId != null)
                    model.append('sendingEntityId', this.document.sendingEntityId);

                if (this.document.sendingDesignatedPersonId != null)
                    model.append('sendingDesignatedPersonId', this.document.sendingDesignatedPersonId);

                model.append('compoRecipientDesignatedPersons', JSON.stringify(this.document.compoRecipientDesignatedPersons));

                if (this.document.tags.length > 0)
                {
                    for(var i = 0; i< this.document.tags.length; i++)
                    {
                        var item = this.document.tags[i];
                        if(item.id <= 0)
                            model.append(`tags[${i}][Id]`, 0);
                        else
                            model.append(`tags[${i}][Id]`, item.id);
                        model.append(`tags[${i}][Name]`, item.name);
                    }
                }

                if (this.document.dueDate != null && this.document.dueDate != undefined && this.document.dueDate != '')
                    model.append('dueDate', this.document.dueDate);
                else
                    model.append('dueDate', '');

                    model.append('priorityId', (this.document.priority == null ? null : this.document.priority.id));
					model.append('privacyId', (this.document.privacy.id == null ? null : this.document.privacy.id) );
                if (this.document.documentType != null && this.document.documentType.id != undefined)
                    model.append('documentTypeId', this.document.documentType.id)
                else
                    model.append('documentTypeId', '')

                if (this.document.importance && this.document.importance.id)
                    model.append('importanceId', this.document.importance.id);

                model.append('classificationId', '');
                if (this.document.cc != null && this.document.cc != undefined) 
                {
                    this.document.cc.forEach(element => {
                        if (element != null && element != undefined && element.id != null && element.id != undefined)
                            model.append('carbonCopy[]', element.id);
                    });
                }
                model.append('register', isRegister);
                model.append('createdByStructureId', this.user_structure.structureId);
                model.append('externalReferenceNumber', this.document.externalReferenceNumber);
                model.append('transferId', '');

                if (this.document.isNeedReply != null)
                    model.append('isNeedReply', this.document.isNeedReply);

                if (this.document.replyDocument != null && this.document.replyDocument != undefined && this.document.replyDocument.id != null && this.document.replyDocument.id != undefined) {
                    model.append('replyDocumentId', this.document.replyDocument.id);
                }
                else
                    model.append('replyDocumentId', 0);

                if (this.document.filingPlanId != null)
                    model.append('filingPlanId', this.document.filingPlanId);

                if (this.document.classificationPlanId != null)
                    model.append('classificationPlanId', this.document.classificationPlanId);

                return model
            },
            saveDocument() 
            {
                var model = this.prepareFormDataObject(false)
                this.log_form_data(model)

                axios.post(constants.baseApiUrl + 'Document/Save', model, { headers: constants.headers })
                    .then(res => {
                        window.showAlert('res_Msgs_ChangesSavedSuccess', 'success')
                        this.linkSourceDocumentAfterSave()
                        if(this.transferId!=null&&this.transferId!=undefined)
                        this.getDocumentWithTransfer()
                    })
                    .catch(error => console.log(error))
            },
            log_form_data(formData) 
            {
                for (var pair of formData.entries())
                    console.log(pair[0] + ': ' + pair[1]);
            },
            isFormValid() 
            {    
                var retVal = true                

                if (!this.collapseDetails && this.user_structure == null || this.user_structure == undefined || this.user_structure.structureId == null || this.user_structure.structureId == undefined) 
                {
                    window.showAlert('res_Msgs_fillUserStructure', 'warning')
                    retVal = false
                }

                if (this.document.sendingEntityId == null || this.document.sendingEntityId == undefined)
                {
                    window.showAlert('res_Msgs_fillSendingEntity', 'warning')
                    retVal = false
                }

                if(this.document.categoryId == 10 && !this.document.requestingDepatment)
                {
                    window.showAlert('res_Msgs_fillRequestingDepartment', 'warning')
                    retVal = false
                }

                if(this.document.categoryId == 10 && !this.document.amount)
                {
                    window.showAlert('res_Msgs_fillAmount', 'warning')
                    retVal = false
                }
                // validate recipient
                if (this.document.compoRecipientDesignatedPersons == null || this.document.compoRecipientDesignatedPersons == undefined || this.document.compoRecipientDesignatedPersons.length == 0)
                {
                    window.showAlert('res_Msgs_fillRecipient', 'warning')
                    retVal = false
                } 

                if (this.document.priority == null || this.document.priority.id == undefined)
                {
                    window.showAlert('res_Msgs_fillPriority', 'warning')
                    retVal = false
                }

                if (this.document.privacy == null || this.document.privacy.id == undefined)
                {
                    window.showAlert('res_Msgs_fillPrivacy', 'warning')
                    retVal = false
                }

                if (this.document.classificationPlanId == null && this.classificationPlanIdRequired)
                {
                    window.showAlert('res_Msgs_FillRequired', 'warning')
                    retVal = false;
                }

                if (constants.showDocumentType)
                {
                    if (this.document.documentType == null || this.document.documentType.id == undefined)
                    {
                        window.showAlert('res_Msgs_fillDocumentType', 'warning')
                        retVal = false	
                    }
                }				
                if (this.document.date == null || this.document.date == undefined || this.document.date == '')
                {
                    window.showAlert('res_Msgs_fillDocumentDate', 'warning')
                    retVal = false
                }

                if (this.document.subject == null || this.document.subject == undefined || this.document.subject.trim() == '')
                {
                    window.showAlert('res_Msgs_fillSubject', 'warning')
                    retVal = false
                }
                else 
                {
                    if (this.document.subject.length > 350) 
                    {
                        window.showAlert("Subject field can't be more than 350 characters", 'warning')
                        return false
                    }
                }

                if (this.document.categoryId == 1)
                {
                    if (this.document.externalReferenceNumber == null || this.document.externalReferenceNumber == undefined || this.document.externalReferenceNumber.trim() == '')
                    {
                        window.showAlert('res_Msgs_fillExternalReferenceNumber', 'warning')  
                        retVal = false
                    }
                }

                if (this.document.categoryId == 3 && this.selectedTemplate != undefined && this.selectedTemplate.isWorkflow == true) 
                {
                    if (this.document.signers == null || this.document.signers == undefined || this.document.signers.length == 0)
                    {
                        window.showAlert('res_Msgs_fillSigners', 'warning')     
                        retVal = false
                    }
                    else 
                    {
                        this.document.signers.forEach(element => 
                        {
                            if (element == undefined || element.name == undefined || element.name == '')
                            {
                                window.showAlert('res_Msgs_fillSigners', 'warning')     
                                retVal = false
                            }
                        });
                    }
                }

                return retVal;
            },
            clearBlockSelections() {
                this.showTranslatedSubjectBlock = false
                this.showCommentsBlock = false
                this.showOtherAttachmentsBlock = false
            },
            notifyEmailCorrespondence(value) {
                this.notifySubject = this.$t('res_Msgs_Reminder') + this.subject;
                this.notifyEmailDialogCorrespondence = value;
            },
            applyChanges() {
                if (this.isFormValid()) {
                    if (JSON.stringify(this.document.signers) != this.documentSignersBackup && this.document.categoryId != 1) {
                        window.showInformation(this.$t('res_Label_Alert'), this.$t('res_Msgs_preconfiguredSignatuesAlert'),
                            () => { this.SaveDocumentCallApi(false) },
                            () => { })
                    }
                    else {
                        this.SaveDocumentCallApi(false);
                    }
                }
            },
            applyChangesAndEdit() {
                if (this.isFormValid()) {
                    if (JSON.stringify(this.document.signers) != this.documentSignersBackup && this.document.categoryId != 1) {
                        window.showInformation(this.$t('res_Label_Alert'), this.$t('res_Msgs_preconfiguredSignatuesAlert'),
                            () => { this.SaveDocumentCallApi(true) },
                            () => { })
                    }
                    else {
                        this.SaveDocumentCallApi(true);
                    }
                }
            },
            SaveDocumentCallApi(withEdit) {
                var model = this.prepareFormDataObject(true)
                window.showLoading()
                axios.post(constants.baseApiUrl + 'Document/Save', model)
                    .then(res => {
                        if (res == undefined || res.data == null) {
                            window.hideLoading();
                            window.showAlert('res_Msgs_ErrorOccured', 'error')
                        }
                        else if (res.data == "ExternalReferencedNumberInUse") {
                            window.hideLoading();
                            window.showAlert("res_Msgs_SameLetterExist", "warning")
                        }
                        else if (res.data == "OriginalFileInUse") {
                            window.hideLoading();
                            window.showAlert("res_Msgs_ErrorFileCheckedOut", "warning")
                        }
                        else
                        {
                            this.linkSourceDocumentAfterSave()
                            axios.get(constants.baseApiUrl + 'Document/save-custom?documentId=' + this.documentId + '&docHashValue=' + this.document.hashValue)
                                .then(res =>
                                {
                                    if (res == undefined || res.data == null) {
                                        window.hideLoading();
                                        window.showAlert('res_Msgs_ErrorOccured', 'error')
                                    }
                                    else {
                                        window.showAlert('res_Msgs_DocumentSavedSuccess', 'success')
                                        if(this.transferId!=null&&this.transferId!=undefined)
                                        this.getDocumentWithTransfer(true)
                                        this.refreshViewer(withEdit)
                                    }
                                })
                                .catch(error => console.log(error))
                                .finally(() => {
                                    window.hideLoading();
                                })
                        }
                    })
                    .catch(err => { this.handleError(err); window.hideLoading(); })
            },
            CapitalizeFirstLetter(str) {
                return utils.CapitalizeFirstLetter(str)
            },
            GetMultiSelectSubHeaderDisplay(options) {
                return utils.GetMultiSelectSubHeaderDisplay(options)
            },
            uploadScan(imageData){
                var requestData = {
                documentId: this.documentId,
                name: this.referenceNumber,
                updateFileData: imageData,
                storageAttachmentId: 0,
                count: 0
            }

            const headers2 = {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + sessionStorage.getItem('jwt_token')
            };

            window.showLoading();
            axios.post(constants.baseApiUrl + 'Document/UploadScan', requestData, { headers: headers2 })
                .then((res) => {
                    if (res.data == true) 
                    {
                         window.showAlert("Updated Successfuly", "success")
                         if(this.transferId != null && this.transferId != undefined)
                         {
                             this.getDocumentWithTransfer();
                         }
                         this.$refs.attachmentCtrl.getAttachments()
                         this.refreshViewer(false)
                         this.openScanDialog = false;
                    }
                    else if (res.data == "DocumentArchived")
                     {
                         window.showAlert("DocumentArchived", "warning")
                     }
                    else
                     {
                         window.showAlert("Document Can't Be modified", "warning")
                     }
                })
                .catch(err => alert(err))
                .finally(() => { window.hideLoading(); });
            },   

 
            
            ApproveDocument(){
                axios.get(constants.baseApiUrl + 'Document/ApproveDocument?documentId=' + this.documentId+'&delegationId='+this.delegationId)
                                .then(res => {
                                    if (res == undefined || res.data == null) {
                                        window.hideLoading();
                                        window.showAlert('res_Msgs_ErrorOccured', 'error')
                                    }
                                    else {
                                        window.showAlert('res_Msgs_DocumentApprovedSuccess', 'success')
                                        if(this.transferId!=null&&this.transferId!=undefined)
                                        this.getDocumentWithTransfer()
                                        this.refreshViewer(false)
                                    }
                                })
                                .catch(error => console.log(error))
                                .finally(() => window.hideLoading())
            } ,
            async signDocument() 
            {
                this.canSignWithoutPinCode = await this.fetchCanSignWithoutPin()
                this.propertyBag.documentId = this.documentId
                this.propertyBag.transferId = this.transferId
                this.propertyBag.delegationId = this.delegationId
                this.propertyBag.documentHashValue = this.document.hashValue
                if (!this.canSignWithoutPinCode && (constants.signUsingUAEPassEnabled || constants.signUsingDocusignEnabled))
                { 
                    if(this.allowESignature && !this.allowUAEPASSSignature)
                        this.closeSignMethodSelectAndOpenSignWithPin();
                    else
                        this.selectSignMethodFormDialog = true
                }
                else
                { 
                    this.signFormDialog = true
                }
            },
            closeSignFormDialog() 
            {
                this.signFormDialog = false
            },
            closeSelectSignMethodFormDialog() {
                this.selectSignMethodFormDialog = false
            },
            refreshAfterClosingSignDialog() {
                this.signFormDialog = false
                this.refreshViewer(false)
                this.$refs.attachmentCtrl.getAttachments()
                if(this.transferId!=null&&this.transferId!=undefined)
                this.getDocumentWithTransfer()
            },
            refreshAfterClosingSignMethodSelect() {
                this.selectSignMethodFormDialog = false
                this.refreshViewer(false)
                this.$refs.attachmentCtrl.getAttachments()
                if(this.transferId!=null&&this.transferId!=undefined)
                this.getDocumentWithTransfer()
            },
            closeSignMethodSelectAndOpenSignWithPin() {
                this.selectSignMethodFormDialog = false
                this.signFormDialog = true
            },
            previewSignature() 
            {
                this.previewSignatureDialog = true
            },
            closeReviewSignatureDialog() 
            {
                this.previewSignatureDialog = false
            },
            async OpenTransferForm(action) 
            {     
                this.canSignWithoutPinCode = await this.fetchCanSignWithoutPin()
				this.sentBack = false;
                this.forwardCc = false
                this.rejected = false
                this.recipientDisabled = false
                this.signForm = false
                this.transferFormType = 'Transfer'

                this.propertyBag.documentId = this.documentId
                this.propertyBag.transferId = this.transferId
                this.propertyBag.delegationId = this.delegationId
                this.propertyBag.documentHashValue = this.document.hashValue

                if (action == 'Endorse')
                {
                    this.recipientDisabled = true
                    this.transferFormType = 'Endorse'
                    this.transferSuccessMessage = 'res_Msgs_DocumentEndorsed'
                    this.transferFormHeader = window.translate("res_MenuItems_Endorse")
                    this.purpose = { id: 8, name: this.selectedLang == 'ar' ? 'للتوقيع' : 'For Signature' }
                    
                    this.getNextReceiver(false, true)

                }
                else if (action == 'Forward') 
                {
                    this.transferSuccessMessage = 'res_Msgs_DocumentForwarded'
                    this.checkForAttachmentsUploadMultiApproval = true
                    this.transferFormHeader = window.translate("res_MenuItems_Forward")
                    this.purpose = { id: 3, name: this.selectedLang == 'ar' ? 'للإجراء اللازم' : 'For Action' }  
                                  
                    this.getNextReceiver(false, false)
                }
                else if (action == 'ForwardCc') 
                {
                    this.transferSuccessMessage = 'res_Msgs_DocumentForwarded'
                    this.checkForAttachmentsUploadMultiApproval = true
                    this.transferFormHeader = window.translate("res_MenuItems_Forward")
                    this.purpose = { id: 10, name: this.selectedLang == 'en' ? 'Cced' : 'نسخة' }
                    this.forwardCc = true
                }
                else if (action == 'Sign') {
                    this.transferSuccessMessage = 'res_Msgs_DocumentSignedAndSent'
                    this.transferFormHeader = window.translate("res_ButtonText_SignAndTransfer")
                    this.purpose = { id: 3, name: this.selectedLang == 'ar' ? 'للإجراء اللازم' : 'For Action' }  
                    this.signForm = true;
                    this.getNextReceiver(true, false)
                }
                else if (action == 'Rejected') {
                    this.transferSuccessMessage = 'res_Msgs_DocumentRejected'
                    this.rejected = true
                    this.signForm = utils.checkCanSignDocument(this.document, this.delegationId, this.document.canSign, 'reject')
                    this.recipientDisabled = true
                    this.transferFormHeader = window.translate("res_MenuItems_Reject")
                    this.purpose = { id: 12, name: this.selectedLang == 'ar' ? 'مرفوض' : 'Rejected' }
                    this.GetInitiator(this.documentId)
                }
                else if (action == 'Send Back') {
                    this.transferSuccessMessage = 'res_Msgs_DocumentSentBack'
                    this.transferFormHeader = window.translate("res_MenuItems_SendBack")
                    this.purpose = { id: 3, name: this.selectedLang == 'ar' ? 'للإجراء اللازم' : 'For Action' }
                    this.recipientDisabled = true
                    this.signForm = false;
                    this.GetPreviousSender(this.transferId);
                    this.sentBack = true;
                }

               let missingOtherAttachments = this.document.otherAttachments == null || this.document.otherAttachments.trim() == '';
		       let missinglinkedDocuments  = this.linkedDocuments == null || this.linkedDocuments.length == 0;

                if( window.enableConfirmOntransferOtherInfo == true  &&
                    (missinglinkedDocuments|| missingOtherAttachments) &&
                    (this.transferId <= 0 || this.transferId == null) && this.document.categoryId == 2
                ){  
                    let missingData = [];
                    if(missinglinkedDocuments)
                    { missingData.push(this.$t('res_CardHeaders_LinkedEmails')); }
                    if(missingOtherAttachments)
                    { missingData.push(this.$t('res_Label_OtherAttachments')); }  
                    let customMessage = missingData.length == 1 ? missingData[0] : `(${missingData.join(',')})`; 
                    window.showInformation(
                    this.$t('res_Msgs_Confirmation'),
                    this.$t('res_Msgs_DocumentHasNoLinkedDocsAndOtherAttachments', { customMessage }),
                    () => { this.transferFormDialog = true },
                    () => {})
                }
                else{
                    this.transferFormType = action
                    this.transferFormDialog = true
                }
            },
            PublishToMultiDocument() {
                window.showLoading()
                axios.get(constants.baseApiUrl + 'Document/CheckCanCompleteDocument?documentId=' + this.documentId + '&transferId=' + this.transferId)
                    .then(res => {
                        if (res.data == 1) {
                            window.hideLoading()
                            window.showInformation(
                                window.translate("res_ButtonText_PublishToMultiDocument"),
                                window.translate("res_Msgs_PublishToMultiDocumentConfirmation"),
                                () => {
                                    window.showLoading()
                                    axios.get(constants.baseApiUrl + 'Document/PublishToMultiDocument?documentId=' + this.documentId)
                                        .then(res => {
                                            window.hideLoading()
                                            this.getDocumentWithTransfer();
                                            window.showAlert('res_Msg_PublishedSuccessfully', 'warning')
                                        })
                                        .catch(error => {
                                            console.log(error)
                                            window.hideLoading()
                                        })
                                },
                                () => { 
                                });
                        }
                        else {
                            window.hideLoading()
                            window.showAlert('res_Msg_CannotPublish', 'warning')
                        }
                    })
                    .catch(error => {
                        console.log(error)
                        window.hideLoading()
                    })

            },
            getNextReceiver(isSign, isEndorse, isRejected) {
                const purposes = getTransferPurposes()
                this.transferCC = []
                this.transferTo = {};
                this.transferToMulti = []

                utils.defaultGet('Transfer/GetDocumentNextDefaultReceiver?docId=' + this.documentId + '&isSign=' + isSign + '&isEndorse=' + isEndorse + '&delegationId=' + this.delegationId,
                (res) => {
                        if (res.data != null && res.data != undefined) {
                            if (res.data.length > 0 && res.data[0].id != 0) {
                                var isMultiForwardEnabled = false
                                var notCcedElements = res.data.filter(x => x.isCced == false)
                                if (notCcedElements.length > 1)
                                    isMultiForwardEnabled = true
                                res.data.forEach(element => {                                   
                                    var purposeName = ''
                                    var selectedPurpose = purposes.find(x => x.id == element.purpose)
                                    if (selectedPurpose != undefined && selectedPurpose != null) {
                                        purposeName = this.selectedLang == 'ar' ? selectedPurpose.nameAr : selectedPurpose.name
                                        this.purpose = { id: element.purpose, name: purposeName }                                     
                                    }
                                    if (element.isCced)
                                        this.transferCC.push(element)
                                    else {
                                        if (element.name != "0") {
                                            if (isMultiForwardEnabled == false)
                                                this.transferTo = element
                                            else
                                                this.transferToMulti.push(element)
                                        }
                                    }
                                });

                            }
                        }
                    }, this.handleError, true);
            },
            GetPreviousSender(transferId) {
                utils.defaultGet('Transfer/GetPreviousSender?transferId=' + transferId,
                    (res) => {
                        if (res.data != null && res.data != undefined && res.data.id != null && res.data.id != undefined) {
                            this.transferTo = res.data
                        }
                    }, this.handleError, true);
            },
            GetInitiator(documentId) {
                utils.defaultGet('Transfer/GetInitiator?documentId=' + documentId,
                    (res) => {
                        if (res.data != null && res.data != undefined && res.data.id != null && res.data.id != undefined) {
                            this.transferTo = res.data
                        }
                    }, this.handleError, true);
            },
            openSigningHistory() {
                this.signingHistoryDialog = true
            },
           openVisualTracking() { 
                if (window.enableVisualTracker2 == true) { 
                    this.visualTrackingDialogNew_selectedDocumentId = this.documentId;
                    this.visualTrackingDialogNew = true;  
                }
                else
                { 
                    this.signingHistoryDialog = false
                    // this.visualTrackingDialog = true 
                    var lang = localStorage.getItem('lang')
                    lang = ((lang == null || lang == undefined) ? 'en' : lang);
                    window.setVisualTrackingData(this.documentId);
                    this.trackingFrameSrc = "/resources/VisualTracking/VisualTracking.html?lang=" + lang + "&r=" + new Date().getTime()
                    window.open(this.trackingFrameSrc, "_blank");
                }
            },
            openCompleteDocumentDialog() {
                window.showLoading()
                let transferIds = this.transferId //this.selected.map(item => item.transferId).join(',') || this.selectedItem.item.transferId;
                let documentIds = this.documentId //this.selected.map(item => item.documentId).join(',') || this.selectedItem.item.documentId;
                let needClassification = window.documentNeedClassification;
                axios.get(constants.baseApiUrl + 'Document/CheckCanCompleteDocument?documentId=' + documentIds + '&transferId=' + transferIds + '&needClassification=' + needClassification)
                    .then(res => 
                    {
                        this.completeDocumentDialog = true
                        this.completeDocument_noteText = ''
                        window.hideLoading()
                    })
                    .catch((err) => { console.log(err); })
                    .finally(() => { window.hideLoading(); })
            },
            completeDocument() 
            {
                if (this.completeDocument_noteText.trim().length == 0 || (utils.CheckIfNullOrEmpty(this.classificationPlanId) && this.showClassificationField == true) || (utils.CheckIfNullOrEmpty(this.dmsSelectedCabinetId) && this.archiveToDMSCabinet == true)) {
                    window.showAlert('res_Msgs_FillRequired', 'warning')
                    return
                }

                let needClassification = window.documentNeedClassification;

                window.showLoading()
                axios.get(constants.baseApiUrl + 'Document/CheckCanCompleteDocument?documentId=' + this.documentId + '&transferId=' + this.transferId + '&needClassification=' + false)
                    .then(res => {
                        if (res.data == 1) {
                            var body = { 
                                documentId: this.documentId,
                                transferId: this.transferId, 
                                instructions: this.completeDocument_noteText, 
                                classificationPlanId: this.showClassificationField == true? this.classificationPlanId : null,
                                delegationId: this.delegationId,
                                DmsCabinetId: this.archiveToDMSCabinet == true? this.dmsSelectedCabinetId : null,

                            };
                            axios.post(constants.baseApiUrl + 'Document/CompleteDocument', body, { headers: constants.headers })
                                .then(res => {
                                    window.showAlert('res_Msgs_DocumentCompletedSuccess', 'success')
                                    this.closeDialog(false, false)
                                })
                                .catch(error => console.log(error))
                                .finally(() => window.hideLoading())
                        }
                        else {
                            window.hideLoading()
                            window.showAlert('res_Msgs_DocumentNotArchived', 'warning')
                        }
                    })
                    .catch(error => {
                        console.log(error)
                        window.hideLoading()
                        this.completeDocumentDialog = false
                    })
            },
            async GetTransferIdForLinkedDocument(documentId)
            {
                try {
                    const res = await axios.get(constants.baseApiUrl + 'LinkedDocument/GetTransferIdForLinkedDocument?documentId=' + documentId)
                    return res.data
                } catch (error) {
                    console.log(error);
                }
            },
            async displayLinkedItem(item) 
            {
                this.linkedDelegationId = 0
                this.linkedDocumentId = item.linkedDocumentId
                this.linkedTransferId = await this.GetTransferIdForLinkedDocument(item.linkedDocumentId)
                this.viewingLinkedDocument = true
                this.dialogCount++;
                this.correspondenceDialog = true
            },
             openLinkedEmailDeleteConfirmation(id)
            {
                this.linkedDocumentToDeleteId = id;
                this.LinkedEmailDeleteDialog = true;
            },
            cancelLinkedEmailDeleteDialog()
            {
                this.LinkedEmailDeleteDialog = false;
                this.linkedDocumentToDeleteId = 0;
            },
            deleteLinkedDocument()
            {
                if (!this.linkedDocumentToDeleteId)
                {
                    this.LinkedEmailDeleteDialog = false
                    return
                }

                axios.get(constants.baseApiUrl + 'LinkedDocument/DeleteLinkedDocument?id=' + this.linkedDocumentToDeleteId + '&documentId=' + this.documentId)
                    .then(response =>
                    {
                        if (response != null)
                        {
                            this.getLinkedDocuments()
                            this.LinkedEmailDeleteDialog = false
                            this.linkedDocumentToDeleteId = 0
                        }
                    })
                    .catch(error => console.log(error))
                    .finally(() => this.loading = false);
            },
            getUserById(userId) {
                axios.get(constants.baseApiUrl + 'User/GetSelectedUserById?userId=' + userId)
                    .then(response => {
                        if (response.data != null) {
                            return response.data.firstName + response.data.lastName;
                        }
                    })
                    .catch(error => console.log(error))
                    .finally(() => this.loading = false);
            },
            linkSourceDocumentAfterSave()
            {
                var storageKey = 'pendingLinkedDocument_' + this.documentId
                var sourceDocumentId = this.linkedFromDocumentId > 0
                    ? Number(this.linkedFromDocumentId)
                    : Number(sessionStorage.getItem(storageKey) || 0)
               
                if (!(this.documentId > 0))
                    return

                if (!(sourceDocumentId > 0) || sourceDocumentId == this.documentId)
                    return

                if (this.linkedDocumentsFullList.some(x => x.linkedDocumentId == sourceDocumentId))
                {
                    sessionStorage.removeItem(storageKey)
                    return
                }

                var user = JSON.parse(sessionStorage.getItem("user"))
                var linkedDocuments = [{
                    DocumentId: Number(this.documentId),
                    LinkedDocumentId: sourceDocumentId,
                    CreatedByUserId: user.profile.Id,
                    TransferId: null
                }]

                axios.post(constants.baseApiUrl + 'LinkedDocument/AddLinkedDocuments', linkedDocuments, { headers: constants.headers })
                    .then((res) => {
                        sessionStorage.removeItem(storageKey)
                        this.getLinkedDocuments()
                    })
                    .catch(error => console.log('[link] AddLinkedDocuments failed', error))
            },
            getLinkedDocuments()
            {
                this.numberOfLinkedDocumentsToDisplay = this.defaultNumberOfLinkedDocumentsToDisplay
                this.linkedDocuments = []
                this.linkedDocumentsFullList = []
                axios.get(constants.baseApiUrl + 'LinkedDocument/GetLinkedDocuments?documentId=' + this.documentId)
                    .then(response => 
                    {
                        response.data.forEach(linkedDocument => {
                            var linkedDoc = {
                                id: linkedDocument.id,
                                isEditable: linkedDocument.isEditable,
                                linkedDocumentId: linkedDocument.linkedDocumentId,
                                transferId: linkedDocument.transferId,
                                subject: linkedDocument.subject,
                                name: linkedDocument.userName,
                                referenceNumber: linkedDocument.referenceNumber,
                                createdDate: linkedDocument.createdDate,
                                createdByUser: linkedDocument.createdByUser,
                                createdByUserId: linkedDocument.createdByUserId,
                                documentId: this.documentId
                            }

                            if (this.linkedDocuments.length < this.defaultNumberOfLinkedDocumentsToDisplay)
                                this.linkedDocuments.push(linkedDoc)

                            this.linkedDocumentsFullList.push(linkedDoc)
                        })
                    })
                    .catch(error => console.log(error))
            },
            viewAllLinkedDocuments() {
                if (this.numberOfLinkedDocumentsToDisplay == 1000) {
                    this.numberOfLinkedDocumentsToDisplay = this.defaultNumberOfLinkedDocumentsToDisplay
                    this.linkedDocuments = this.linkedDocumentsFullList.slice(0, this.defaultNumberOfLinkedDocumentsToDisplay)
                }
                else {
                    this.numberOfLinkedDocumentsToDisplay = 1000
                    this.linkedDocuments = this.linkedDocumentsFullList
                }
            },
            closeLinkedDocumentPopup()
            {
                this.linkedDocumentDialog=false
                this.$refs.linkedDocument.reset();
            },
            closeSelectLinkedDocumentPopup() {
                this.linkedDocumentDialog = false;
                this.getLinkedDocuments();
                this.$refs.linkedDocument.reset();
            },
            addLinkedDocuments() {
                this.linkedDocumentDialog = true;
            },
            downloadWithAttachments() {
                   utils.DownloadFile(constants.baseApiUrl + 'Document/DownloadWithAttachments?documentId=' + this.documentId, this.truncateFilename(this.document.subject + '-' + this.document.referenceNumber + '.pdf', 100))                                                        
            },
            downloadWithoutHeaederAndWithSignature(){
                axios({
                    url: constants.baseApiUrl + "Document/Downloadwithoutheaderandsignture?documentId=" + this.documentId+'&removeHeader=true',
                    method: "GET",
                    responseType: "blob", // important
                })
				.then((res) => {
					var blob = new Blob([res.data], { type: "application/octetstream" });

					const link = window.URL.createObjectURL(blob);
					const a = document.createElement("a");                   
                    a.setAttribute("download",this.truncateFilename(this.document.subject + '-' + this.document.referenceNumber + '.pdf', 100));                   
					
					a.setAttribute("href", link);
					document.body.appendChild(a);
					a.click();
					document.body.removeChild(a);
				})
				.catch((error) => {
					console.log(error);
					window.hideLoading();
				});        
            },
            // downloadPlainLetter(){
            //     axios({
            //         url: constants.baseApiUrl + "Document/Downloadwithoutheaderandsignture?documentId=" + this.documentId,
            //         method: "GET",
            //         responseType: "blob", // important
            //     })
			// 	.then((res) => {
			// 		var blob = new Blob([res.data], { type: "application/octetstream" });

			// 		const link = window.URL.createObjectURL(blob);
			// 		const a = document.createElement("a");                   
            //         a.setAttribute("download",this.truncateFilename(this.document.subject + '-' + this.document.referenceNumber + '.pdf', 100));                   
					
			// 		a.setAttribute("href", link);
			// 		document.body.appendChild(a);
			// 		a.click();
			// 		document.body.removeChild(a);
			// 	})
			// 	.catch((error) => {
			// 		console.log(error);
			// 		window.hideLoading();
			// 	});        
            // },
            downloadAttachmentWithStamps() {
                axios.get(constants.baseApiUrl + 'ViewerActions/DownloadWithAnnotation?id=' + this.attachmentId, {responseType: 'blob'})
                .then(response => {
                    const href = window.URL.createObjectURL(response.data);

                    // create "a" HTML element with href to file & click
                    const link = document.createElement('a');
                    link.href = href;                   
                    link.setAttribute('download', this.truncateFilename(this.document.subject + '-' + this.document.referenceNumber + '.pdf', 100)); //or any other extension                                    
                    document.body.appendChild(link);
                    link.click();

                    // clean up "a" element & remove ObjectURL
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(href);
                })
                .catch(error => console.log(error))
                .finally(() => window.hideLoading())
            },
            printWithAttachments() {
                utils.PrintFile(constants.baseApiUrl + 'Document/DownloadWithAttachments?documentId=' + this.documentId, 'print.pdf')
            },
            createCopyFromLetter() 
            {
                window.showInformation(this.$t('res_Label_Alert'), this.$t('res_Msgs_copyLetterAlert'),
                    () => {
                        window.showLoading()
                        axios.post(constants.baseApiUrl + 'Document/CreateCopy?documentId=' + this.documentId)
                            .then(response => 
                            {
                                if (response.data != null) 
                                {
                                    var newDocumentId = response.data
                                    window.openNewCorrespondenceDialog(newDocumentId)
                                }
                            })
                            .catch(error => console.log(error))
                            .finally(() => window.hideLoading())
                    },
                    () => { });
            },
            printBarcode() 
            {
                const newWindow = window.open();
                var img = new Image();
                img.src = this.barcodeImage;
                newWindow.document.body.appendChild(img);
                newWindow.focus();
                newWindow.print();
                newWindow.close();
            },
            ViewBarcode() 
            {
                if (this.document.referenceSequence && this.document.referenceSequence > 0) 
                {
                    var date = this.document.createdDate.split(' ')

                    this.loading = true
                    axios.get(constants.baseApiUrl + 'Document/GetBarcode?docReference=' + this.document.referenceNumber + '&datetime=' + date[0] + '&timeOnly=' + date[1])
                        .then(response => {
                            this.barcodeFormDialog = true
                            this.barcodeImage = "data:image/jpg;base64," + response.data;
                            this.loading = false
                        })
                        .catch(error => {
                            console.log(error)
                            this.loading = false
                        }

                        )
                        .finally(() => this.loading = false);
                }
                else {
                    window.showAlert('res_Msgs_CorrespondenceDontHaveReferenceNumber', 'error')
                }
            },
            hideBarCode() {
                this.barcodeFormDialog = false
            },
            isSendBackEnabled() {
                // 8: For Signature, 15: For Endorsement
                return (this.document.isRegistered === true && this.document.cCed == false)
            },
            isRejectEnabled() {
                // 8: For Signature, 15: For Endorsement
                return (this.document.isRegistered === true && this.document.categoryId != 1 && this.IsCced() == false && (this.document.purposeId === constants.purposesEnum.ForSignature || this.document.purposeId === constants.purposesEnum.ForAction))
            },
            isDocumentArchived() {
                return this.document?.statusId == constants.statusesEnum.completed.value  || this.openedFromNodeId == 8
            },
            canAddEditAttachments(action = 'edit') {
            
                if (this.isDocumentArchived())
                    return false

                if (this.viewMode == "edit" || this.viewMode == "edit_new")
                    return true

                if (action == 'add')
                    return true

                return false
            },
            canAddEditLinkedDocuments() {
                if (this.document.purposeId == constants.purposesEnum.CCed)
                    return false

                // if (this.viewMode == "edit" || this.viewMode == "edit_new")
                //     return true;

                return true;
            },
            canAddEditNotes() {
                if (this.document.purposeId == constants.purposesEnum.CCed)
                    return false

                if (this.viewMode == "edit" || this.viewMode == "edit_new" || this.document.statusId == 5 || this.document.statusId == 3)
                    return true

                return false
            },
            recall() {
                window.showInformation(window.translate("res_Msgs_Confirmation"), window.translate("res_Msgs_TransferRecallConfirmation"),
                    () => {
                        utils.defaultPost('Document/Recall?transferId=' + this.transferId, null,
                            (res) => {
                                if (res.data.item1 == true) {
                                    window.showAlert('res_Msgs_TransferRecalled', 'success')
                                    this.closeDialog(false, false)
                                }
                                else {
                                    window.showAlert('res_Msgs_TransferRecallFailed', 'warning')
                                }
                            }, this.handleError, true);
                    },
                    () => { })
            },
            signeesOnDrop(dropResult, generateAdvancedReferenceNumber = false) {
                if(generateAdvancedReferenceNumber == false)
                    this.document.signers = utils.applyDrag(this.document.signers, dropResult)
                else
                    this.signers_GenerateReferenceNumberAdvance = utils.applyDrag(this.signers_GenerateReferenceNumberAdvance, dropResult)
            },
            canEditDocumentMetaData() 
            {
                var canEdit= 0;
                if(OnlyCreatorCanEditDocument)
                    canEdit= (this.viewMode == 'edit' || this.viewMode == 'edit_new') && (this.document.canUserEdit) && this.document.openedByCreator 
                else
                    canEdit= (this.viewMode == 'edit' || this.viewMode == 'edit_new') && (this.document.canUserEdit)
                return canEdit
            },
            forceGenerateReferenceNumber() {
                window.showLoading();
                axios.post(constants.baseApiUrl + 'Document/ForceGenerateReferenceNumber?documentId=' + this.documentId + '&forcedGereration=' + true.toString(), null)
                    .then((res) => {
                        if (res && res.data == "HasReferenceNumber")
                            window.showAlert(this.$t('res_Msgs_ThisDocumentAlreadyHasReferenceNumber'), 'warning');
                        else
                        {
                            this.refreshViewer(false);
                            if(this.transferId!=null&&this.transferId!=undefined)
                            this.getDocumentWithTransfer();
                        }
                    })
                    .catch(error => console.log(error))
                    .finally(()=> { window.hideLoading();})
            },
            forceGenerateAdvance() 
            {
                let formValid = false;
                let signersList = [];
                if (this.signers_GenerateReferenceNumberAdvance <= 0) 
                { 
                    window.showAlert(this.$t('res_Msgs_fillSigners'), "warning");
                    return;
                }

                for (let i = 0; i < this.signers_GenerateReferenceNumberAdvance.length; i++) 
                {
                    if (this.signers_GenerateReferenceNumberAdvance[i].id == undefined) 
                    {
                        window.showAlert(this.$t('res_Msgs_fillSigners'), "warning");
                        return;
                    }
                }

                this.forceGenerateAdvance_UploadLoader = true;
                for (let i = 0; i < this.signers_GenerateReferenceNumberAdvance.length; i++) 
                {
                    if (this.signers_GenerateReferenceNumberAdvance[i].id != undefined) {
                        signersList.push(this.signers_GenerateReferenceNumberAdvance[i].id);
                        formValid = true;
                    }
                }
                if (!formValid) {
                    window.showAlert(this.$t('res_Msgs_FillRequired'), "warning");
                }

                // if (this.signers_GenerateReferenceNumberAdvance.length < this.documentSignersCount) {
                //     window.showAlert(this.$t('res_Msgs_fillSigners'), "warning");
                //     formValid = false;
                // }

                let isDuplicate = signersList.some((val, i) => signersList.indexOf(val) !== i);
                if(isDuplicate) { 
                    window.showAlert(this.$t('res_Msgs_DuplicateSigners'), "warning");
                    formValid = false;
                }

                if (!formValid) {
                    this.forceGenerateAdvance_UploadLoader = false;
                    return;
                }

                axios.get(constants.baseApiUrl + `Document/GenerateReferenceNumberAdvance?documentId=${this.documentId}&signersList=${signersList.join(',')}`)
                    .then((res) => {
                        this.closeGenerateAdvanceDialog();
                        if (res && res.data && res.data.retVal == true) {
                            this.refreshViewer(false);
                            if (this.transferId != null && this.transferId != undefined)
                            {
                                this.getDocumentWithTransfer();
                            }
                        }
                        else {
                            window.showAlert(this.$t('res_Msgs_GenerateAdvancedFailed'), "warning")
                        }
                    })
                    .catch(error => console.log(error))
                    .finally(() => {
                        this.forceGenerateAdvance_UploadLoader = false;
                    });
            },
            GetDocumentSigners() {
                axios.get(constants.baseApiUrl + 'Document/GetDocumentSignersCount?documentId=' + this.documentId)
                    .then((res) => {
                        if (res && res.data > 0) {
                            this.documentSignersCount = res.data;
                            this.showGenerateAdvance = true;
                        }
                        else {
                            window.showAlert(this.$t('res_Msgs_NoSigners'), "warning")
                            this.documentSignersCount = 0;
                            this.showGenerateAdvance = false;
                        }
                    })
                    .catch(error => console.log(error))
            },
            addFavoriteDocument(){
                if(this.favoriteName.length == 0){
                    window.showAlert(this.$t('res_Msgs_FillRequired'),"warning")
                    return
                }
                axios.get(constants.baseApiUrl + `Document/AddFavorite?name=${this.favoriteName}&documentId=${this.documentId}`)
                .then((res) => {
                    if(res.data == false)
                        return window.showAlert(this.$t('res_Msgs_FavoriteAlreadyExistWithThisName'),"warning")
                    this.addFavoriteDialog = false;
                    this.checkFavorite();
                    window.showAlert(this.$t('res_Msgs_FavoriteAdded'),"success")
                })
                .catch(error => console.log(error));
            },
            removeFavorite(){
                axios.get(constants.baseApiUrl + `Document/DeleteFavorite?documentId=${this.documentId}`)
                .then((res) => {
                    this.removeFavoriteDialog = false;
                    this.checkFavorite();
                    window.showAlert(this.$t('res_Msgs_FavoriteRemoved'),"success")
                })
                .catch(error => console.log(error));
            },
            checkFavorite(){
                axios.get(constants.baseApiUrl + `Document/CheckFavorite?documentId=${this.documentId}`)
                    .then((res) => {
                        this.isFavorite = false;
                        if (res != null && res != undefined && res.data != null) {
                            if (res.data == true)
                                this.isFavorite = true;
                        }
                })
                .catch(error => console.log(error));
            },
            handleShowReplyDocumentSection(){
                if(!this.showReplyDocumentSection)
                    this.document.replyDocument = null
            },
            dispatchCorrespondence()
            {
                if(constants.enableDirectDispatch)
                    this.dispatchCorrespondenceFormDialog = true
                else
                    this.dispatchCorrespondenceFormDialog1 = true
            },
            dispatchCorrespondenceByEmail()
            {
                this.dispatchCorrespondenceByEmailDialog = true
            },
            searchTags(query){
                if(query.length < 2){
                    return
                }
                axios.get(constants.baseApiUrl + `Document/SearchTags?query=${query}`)
                .then(res => {
                    this.tagOptions = res.data;
                })
                .catch(error => console.log(error));

            },
            addTag(tag){
                if(!constants.userActions.features.some(x=>x.name.toLowerCase() == constants.actionsEnum.features.DocumentTagsAdd.key)){
                    window.showAlert(this.$t('res_Msgs_PermissionAddTags'), "warning")
                    return
                }
                if(tag.length < 2){
                    window.showAlert(this.$t('res_Msgs_MinTwoDigit'), "warning")
                    return
                }
                const randomId = new Date().getTime() * -1
                var newTag = { id: randomId, name: tag};
                this.tagOptions.push(newTag);
                this.document.tags.push(newTag);
            },
            openDeliveryNote(document)
            {
                if(!(document.statusId == 3 || document.statusId == 5))
                {
                    window.showAlert(this.$t('res_Msgs_TheCorrespondenceMustBeSignedFirst'), 'warning')
                    return;
                }

                window.showLoading();
                axios.get(constants.baseApiUrl + 'DeliveryNote/GetDeliveryNoteData?documentId=' +  this.documentId)
                    .then((res) => 
                    {
                        
                        if (res.data == true)
                        {
                            window.showAlert(this.$t('res_Msgs_DeliveryNoteCreationValidation'), 'warning')
                        }
                        else
                        {
                            this.referenceNumber = document.referenceNumber;
                            this.deliveryNoteDialog = true;
                        }
                    })
                    .catch((err) => { console.log(err); })
                    .finally(()=>{ window.hideLoading(); })
            },
            closeDeliveryNoteDialog()
            {
                this.deliveryNoteDialog = false
            },
            SaveForLater()
            {
                if(this.hideToDate == ''){
                    window.showAlert(this.$t('res_Msgs_FillRequired'),'warning')
                    return
                }
                window.showLoading();
                axios.get(constants.baseApiUrl + 'Document/SaveForLater?transferId=' +  this.transferId + '&toDate=' + this.hideToDate)
                .then((res) => {
                    if(res.data == false){
                        window.showAlert(this.$t('res_Msgs_TransferNotFound'), "warning")
                    }
                    this.hideCorrespondenceDialog = false;
                    this.hideToDate = '';
                    this.hideToDateMenu = false;
                    this.closeDialog(false, false);
                })
                .catch((err) => { console.log(err); })
                .finally(()=>{ window.hideLoading(); })
            },
            filingPlanSelectChanged(obj) {
                this.$set(this.document, 'filingPlanId', obj != null ? obj.id : null);
            },
            classificationPlanSelectChanged(obj) {
                this.classificationPlanId = obj != null ? obj.id : null;
                this.$set(this.document, 'classificationPlanId', obj != null ? obj.id : null);
            },
            dmsCabinetSelectChanged(dmsSelectedCabinet){
                console.log("dmsCabinet: " + dmsSelectedCabinet)
                this.dmsSelectedCabinetId = (dmsSelectedCabinet != null)? dmsSelectedCabinet.id : null;
            },
            async getEditSignedPermissionRecordFlag() {
                if (this.documentId == null || this.documentId == undefined || this.documentId == 0) {
                    this.hasEditSignedPermissionRecord = false;
                    return;
                }

                axios.get(constants.baseApiUrl + 'Document/hasEditSignedPermissionRecords?documentId=' +
                    this.documentId + '&transferId=' + this.transferId, { headers: constants.headers })
                    .then(response => {
                        this.hasEditSignedPermissionRecord = (response != null && response.data === true)
                    }).catch(err => console.warn(err))
            },
            resetDocument()
            {
                window.showInformation(this.$t('res_Label_Alert'), this.$t('res_Msgs_ResetDocumentConfirmation'),
                    () => {
                        window.showLoading();
                        axios.patch(constants.baseApiUrl + 'Document/ResetDocument?documentId=' + this.documentId + '&transferId=' + this.transferId, null)
                        .then(async (res) => {
                            if (res && res.data == "AdvanceGeneratedReferenceNumberAndReplacedOrginialMail") {
                                window.showAlert(this.$t('res_Msgs_CannotResetAdvanceGeneratedRefNumAndReplacedOrignal'), 'warning')
                                return
                            }
                            if (!utils.CheckIfNullOrEmpty(res)) {
                                window.showAlert('res_Msgs_SuccessTheDocumentHasBeenReset', 'success')
                                this.$refs.attachmentCtrl.getAttachments()
                            }
                            if(this.transferId!=null&&this.transferId!=undefined)
                            {
                                await this.getDocumentWithTransfer();
                                this.refreshViewer(false);
                                //this.closeDialog(false,false)
                            }
                        })
                        .catch(error => console.log(error))
                        .finally(() => { window.hideLoading(); })
                    },
                    () => { });
            },
            cancelCorrespondence()
            {
                window.showInformation(this.$t("res_Msg_DeleteConfirmation"), this.$t("res_Msgs_CloseCorrespondenceConfirmation"),
                    () => {
                        axios.get(constants.baseApiUrl + 'Document/CancelCorrespondence?documentId=' +
                            this.documentId, { headers: constants.headers })
                            .then(res =>
                            {
                                if(res.data != null){
                                    
                                    window.showAlert('res_Msgs_CorrespondenceCanceled', 'success')
                                }
                            })
                            .catch(err => console.warn(err))
                    },
                    () => { });
            },
            completeTransfers(transferId)
            {
                window.showInformation(window.translate('res_Msgs_Confirmation'), window.translate('res_Msgs_TransferCompleteConfirmation'),
                    () => 
                    {
                        var transferIds = [transferId]
                        axios.post(constants.baseApiUrl + 'Transfer/CompleteTransfers?transferIds=' + transferIds)
                            .then(response => 
                            {
                                if (response.data != null && response.data.length > 0) 
                                {
                                    window.showAlert('res_Msgs_TransferCompleted', 'success');
                                    this.closeDialog(false, false)
                                }
                            })
                            .catch(error => console.warn(error));
                    }, () => { });
            },
            dismissSent(transferId)
            {
                window.showLoading();
                axios.post(constants.baseApiUrl + 'Transfer/DismissSentTransfer?transferId=' + transferId)
                    .then(res => {
                        if (res.data != 0) {
                            window.showAlert('res_Msgs_TransferDismiss', 'success')
                            this.closeDialog(false, false)
                        }
                    })
                    .catch(error => console.log(error))
                    .finally(() => window.hideLoading())
            },
            DismissCced(transferId) {
            window.showInformation('res_Msgs_Confirmation', window.translate("res_Msgs_TransferDismissConfirmation"),
                () => {
                    window.showLoading()
                    axios.get(constants.baseApiUrl + 'Transfer/DismissCcedTransfer?transferId=' + transferId)
                        .then(res => {
                            if (res.data != null && res.data > 0) {
                                window.showAlert('res_Msgs_TransferDismiss', 'success')
                                this.closeDialog(false, false)
                            }
                        })
                        .catch(err => console.warn(err))
                        .finally(() => { window.hideLoading(); })
                }, () => { });
            },
            openDmsCabinetSelector(){
                alert("ArchiveToDMSCabinet")
            },
            deleteDraftDocument(document) {
                if (![1,2].includes(document.statusId)) {
                    window.showAlert('res_Msgs_CantDeleteAlreadyRegisteredDocument', 'error');
                    return;
                }

                var hasReferenceSequence = document.referenceSequence != null &&document.referenceSequence != ''

                if(hasReferenceSequence)
                    return window.showAlert('res_Msgs_CantDeleteDraftWithRefSequence', 'error');
                
                let description = utils.describeCorrespondence(document);
                let confirmation = utils.escapeHTML(this.$t('res_Msgs_DeleteDraftsConfirmation'));

                if (description)
                    confirmation += '<br><br>' + description;

                window.showInformation(this.$t('res_Msgs_Confirmation'), confirmation,
                
                () => {
                    window.showLoading()
                    axios.post(constants.baseApiUrl + 'Document/Delete?documentId=' + document.id)
                    .then((res) => {
                        if (res.data == true) {
                            window.showAlert('res_Msgs_DraftDocumentDeleted', 'success')
                            this.closeDialog(false, false)
                        }
                        else {
                            window.showAlert('res_Msgs_DraftDocumentDeletionFailed', 'error')
                        }
                    })
                    .catch((err) => { console.log(err); window.hideLoading(); })
                    .finally(() => { window.hideLoading(); })
                }, () => { }, true);
            },
        },
        computed: {
            hideEditInWord()
            {
                return this.openedFromNodeId != 1 && this.openedFromNodeId != 2
            },
            nextDate()
            {
                const currentDate = new Date();
                currentDate.setDate(currentDate.getDate() + 1);
                return currentDate.toISOString().slice(0, 10); 
            },
        }
    }
</script>


<style>
    #saveAndEditIconlbl:hover {
        text-decoration: underline !important;
    }
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>  


.actions-row {
    flex-wrap: nowrap;
    min-width: 0;
}

/* keep natural widths so the measured width matches the rendered width */
.actions-row > * {
    flex: 0 0 auto;
}

/* set by measureFooterButtons on the buttons that do not fit; the matching
   More Actions entry is rendered in their place */
.actions-row .action-overflowed {
    display: none !important;
}

 
.TemplateCard_En { 
    border: #d8dcde 0.5px solid !important; 
    position: absolute;
    bottom: -140px;  
    height: 160px;
    width: 200px;
}

.TemplateCard_Ar
{ 
    border: #d8dcde 0.5px solid !important;  
    bottom: -140px;  
    position: absolute; 
    height: 160px;
    width: 200px;
}
 
.TemplateInfoTitle
 {
    font-size: 15px !important;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    line-height: 20px !important;
    max-height: 80px;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    white-space: pre-line;

 }
.dgs-card-container{ 
    position: relative;
}

    .ForceGenerateReferenceNumberBtn {
        background-color: #ECF5FF !important;
    }

        .ForceGenerateReferenceNumberBtn:hover {
            background-color: white !important;
            box-shadow: 5px 5px 10px rgba( 0.2, 0.2, 0.2, 0.2) !important;
            border: 0.2px solid #f1efeffa;
        }

        .ForceGenerateReferenceNumberBtn:active {
            background-color: white !important;
            box-shadow: 5px 5px 10px rgba(0,0,0,0.3) !important;
        }

        .ForceGenerateReferenceNumberBtn:focus {
            background-color: white !important;
            box-shadow: 5px 5px 10px rgba(0,0,0,0.3) !important;
        }
 
			   
    .multiselect__select {
        display: none !important;
    }

    .opacity-ghost {
        transition: all .18s ease;
        opacity: 0.8;
    }

    .opacity-ghost-drop {
        opacity: 1;
        background-color: white;
        box-shadow: 3px 3px 10px 3px rgba(0, 0, 0, 0.0);
    }

    .opacity-ghost label, .opacity-ghost .v-icon, .opacity-ghost button {
        display: none;
    }

    .opacity-ghost .multiselect__tags {
        background: white !important;
    }


.FullView-Div-DocumentSubject
{ 
     display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
    word-break: break-word;
    cursor: default !important;
}


</style>